(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["body-part-selector"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.bps:not([data-bps-init])');
  sections.forEach(initBps);

  function initBps(root) {
    root.setAttribute('data-bps-init', '1');
    const dataEl = root.querySelector('[data-bps-data]');
    if (!dataEl) return;

    let data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.warn('Body part selector data parse failed', e);
      return;
    }

    const state = { region: 'all', query: '', selected: null };

    const searchInput = root.querySelector('[data-bps-search]');
    const clearBtn = root.querySelector('[data-bps-clear]');
    const chipsWrap = root.querySelector('[data-bps-chips]');
    const resultsList = root.querySelector('[data-bps-results]');
    const resultsTitle = root.querySelector('[data-bps-results-title]');
    const resultsWrap = root.querySelector('[data-bps-results-wrap]');
    const countEl = root.querySelector('[data-bps-count]');
    const emptyEl = root.querySelector('[data-bps-empty]');
    const bannerText = root.querySelector('[data-bps-banner-text]');
    const selectionEmpty = root.querySelector('[data-bps-selection-empty]');
    const selectionActive = root.querySelector('[data-bps-selection-active]');
    const selectionName = root.querySelector('[data-bps-selection-name]');
    const viewBtns = root.querySelectorAll('.bps__view-btn');
    const svgs = root.querySelectorAll('.bps__svg');

    const isMobile = function () {
      return window.matchMedia('(max-width: 880px)').matches;
    };

    function regionLabel(id) {
      const r = data.regions.find(function (x) { return x.id === id; });
      return r ? r.label : 'Scans';
    }

    data.regions.forEach(function (r) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bps__chip';
      btn.dataset.region = r.id;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', r.id === state.region ? 'true' : 'false');
      btn.textContent = r.label;
      if (r.id === state.region) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        state.region = r.id;
        state.query = '';
        searchInput.value = '';
        clearBtn.hidden = true;
        clearSvgActive();
        bannerText.textContent = r.id === 'all' ? 'Showing all scans — refine with a region or search' : 'Showing scans for ' + r.label;
        render();
      });
      chipsWrap.appendChild(btn);
    });

    searchInput.addEventListener('input', function () {
      state.query = searchInput.value.trim().toLowerCase();
      clearBtn.hidden = state.query === '';
      if (state.query) {
        state.region = 'all';
        clearSvgActive();
        bannerText.textContent = 'Searching for "' + state.query + '"';
      }
      render();
    });

    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      state.query = '';
      clearBtn.hidden = true;
      searchInput.focus();
      render();
    });

    viewBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const view = btn.dataset.view;
        viewBtns.forEach(function (b) {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        svgs.forEach(function (svg) {
          svg.classList.toggle('is-active', svg.classList.contains('bps__svg--' + view));
        });
      });
    });

    root.querySelectorAll('.bps__zone').forEach(function (zone) {
      zone.addEventListener('click', function () { activateZone(zone); });
      zone.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateZone(zone);
        }
      });
    });

    function activateZone(node) {
      const id = node.dataset.region;
      const targetRegion = data.regionMap[id] || 'all';
      const label = node.dataset.label || node.getAttribute('aria-label') || '';

      clearSvgActive();
      node.classList.add('is-active');

      state.region = targetRegion;
      state.query = '';
      searchInput.value = '';
      clearBtn.hidden = true;

      bannerText.textContent = 'Showing scans for ' + label;
      render();

      if (isMobile()) {
        window.requestAnimationFrame(function () {
          resultsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    function clearSvgActive() {
      root.querySelectorAll('.bps__zone.is-active').forEach(function (z) {
        z.classList.remove('is-active');
      });
    }

    const backBtn = root.querySelector('[data-bps-back-to-top]');
    if (backBtn) {
      backBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const selector = (root.getAttribute('data-scroll-target') || '').trim();
        const offset = parseInt(root.getAttribute('data-scroll-offset') || '0', 10) || 0;
        let target = null;
        if (selector) {
          try { target = document.querySelector(selector); } catch (err) { target = null; }
        }
        if (target) {
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });
    }

    function render() {
      const filtered = data.parts.filter(function (p) {
        if (state.region !== 'all' && p.region !== state.region) return false;
        if (state.query) {
          const hay = (p.name + ' ' + (p.kw || '')).toLowerCase();
          if (hay.indexOf(state.query) === -1) return false;
        }
        return true;
      });

      countEl.textContent = filtered.length + (filtered.length === 1 ? ' scan' : ' scans');
      resultsTitle.textContent = state.region === 'all' && !state.query ? 'All scans' : regionLabel(state.region) + ' scans';

      root.querySelectorAll('.bps__chip').forEach(function (chip) {
        const active = chip.dataset.region === state.region;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      resultsList.innerHTML = '';
      if (filtered.length === 0) {
        emptyEl.hidden = false;
        resultsList.style.display = 'none';
      } else {
        emptyEl.hidden = true;
        resultsList.style.display = '';
        filtered.forEach(function (p) {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'bps__result';
          btn.setAttribute('role', 'option');
          if (state.selected === p.name) btn.classList.add('is-selected');
          let sideTag = '';
          if (p.side === 'left') sideTag = '<span class="bps__side-tag">L</span>';
          else if (p.side === 'right') sideTag = '<span class="bps__side-tag">R</span>';
          btn.innerHTML = '<span class="bps__result-radio" aria-hidden="true"></span><span class="bps__result-name">' + escapeHtml(p.name) + '</span>' + sideTag;
          btn.addEventListener('click', function () {
            state.selected = p.name;
            selectionName.textContent = p.name;
            selectionEmpty.hidden = true;
            selectionActive.hidden = false;
            render();
            window.requestAnimationFrame(function () {
              selectionActive.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            });
          });
          li.appendChild(btn);
          resultsList.appendChild(li);
        });
      }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    render();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinic-mri-booking"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-cmb-section]:not([data-cmb-init])');
  sections.forEach(initBookingFlow);

  function initBookingFlow(root) {
    root.setAttribute('data-cmb-init', '1');

    const overlay = root.querySelector('[data-cmb-overlay]');
    const triggerBtns = root.querySelectorAll('[data-cmb-open]');
    const closeBtn = root.querySelector('[data-cmb-close]');
    const backBtn = root.querySelector('[data-cmb-back]');
    const nextBtn = root.querySelector('[data-cmb-next]');
    const nextLabel = root.querySelector('[data-cmb-next-label]');
    const stepTabs = root.querySelectorAll('[data-cmb-step-tab]');
    const panels = root.querySelectorAll('[data-cmb-panel]');
    const summaryEl = root.querySelector('[data-cmb-summary]');
    const errorEl = root.querySelector('[data-cmb-error]');
    const step1ErrorEl = root.querySelector('[data-cmb-step1-error]');

    function showStep1Error() {
      if (!step1ErrorEl) return;
      const secondPickerMounted = pickerInited && pickerInited[2];
      step1ErrorEl.textContent = secondPickerMounted
        ? 'Please select a second body part from the list, or remove the second slot to continue.'
        : 'Please add a second body part using the button below.';
      step1ErrorEl.hidden = false;
      try { step1ErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
    function hideStep1Error() {
      if (step1ErrorEl) step1ErrorEl.hidden = true;
    }
    const loadingEl = root.querySelector('[data-cmb-loading]');
    const postcodeInput = root.querySelector('[data-cmb-postcode]');
    const locationsList = root.querySelector('[data-cmb-locations]');
    const locationsEmpty = root.querySelector('[data-cmb-locations-empty]');
    const locationsNoHeart = root.querySelector('[data-cmb-locations-no-heart]');
    const locationIntro = root.querySelector('[data-cmb-location-intro]');
    const addonBtns = root.querySelectorAll('[data-cmb-addon]');
    const totalSummary = root.querySelector('[data-cmb-total-summary]');
    const totalPrice = root.querySelector('[data-cmb-total-price]');
    const footerTotalValue = root.querySelector('[data-cmb-footer-total-value]');

    // Variant + price config from data attributes (variant IDs) and section settings.
    const variants = {
      base: root.dataset.baseVariant || '',
      heart: root.dataset.heartVariant || '',
      prostate: root.dataset.prostateVariant || '',
      heartProstate: root.dataset.heartProstateVariant || '',
      partBody1: root.dataset.partBody1Variant || '',
      partBody2: root.dataset.partBody2Variant || ''
    };

    const PRICES = { base: 1499, heart: 700, prostate: 600 };

    const offers = {
      partBody1: root.dataset.offersPartBody1 === '1',
      partBody2: root.dataset.offersPartBody2 === '1',
      fullBody: root.dataset.offersFullBody === '1',
      cardiac: root.dataset.offersCardiac === '1',
      prostate: root.dataset.offersProstate === '1'
    };
    const defaultScanType = root.dataset.defaultScanType || 'fullBody';

    // Part Body picker config (regions, parts list, etc.)
    const partBodyDataEl = root.querySelector('[data-cmb-data]');
    let partBodyData = null;
    if (partBodyDataEl) {
      try { partBodyData = JSON.parse(partBodyDataEl.textContent); } catch (e) { partBodyData = null; }
    }
    const partBodyPickerWrap = root.querySelector('[data-cmb-part-body-picker]');
    const pickersWrap = root.querySelector('[data-cmb-pickers]');
    const addSecondCta = root.querySelector('[data-cmb-second-cta]');
    const addSecondBtn = root.querySelector('[data-cmb-add-second]');
    const removeSecondWrap = root.querySelector('[data-cmb-remove-second]');
    const removeSecondBtn = root.querySelector('[data-cmb-remove-second-btn]');

    const state = {
      step: 1,
      scanType: defaultScanType,
      partBodyChoice: null,
      parts: [null, null],
      partsUi: [
        { region: 'all', side: 'all', query: '' },
        { region: 'all', side: 'all', query: '' }
      ],
      addons: { heart: false, prostate: false },
      location: null,
      patient: {
        firstName: '',
        lastName: '',
        phone: '',
        dob: '',
        gender: '',
        preferredDate: '',
        timePreference: '',
        pacemaker: '',
        clinicalReason: ''
      }
    };

    const leadDays = parseInt(root.dataset.minLeadDays || '10', 10) || 10;
    const getMinDate = function () {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + leadDays);
      return d;
    };
    const toIso = function (d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd;
    };
    const getMinIso = function () { return toIso(getMinDate()); };
    const dateLabelFmt = (function () {
      try {
        return new Intl.DateTimeFormat(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) { return null; }
    })();
    const formatLongDate = function (d) {
      return dateLabelFmt ? dateLabelFmt.format(d) : toIso(d);
    };

    const preferredDateInput = root.querySelector('[data-cmb-field="preferredDate"]');
    const preferredDateHint = root.querySelector('[data-cmb-pd-hint]');
    const preferredDateError = root.querySelector('[data-cmb-pd-error]');

    const refreshPreferredDateHint = function () {
      if (!preferredDateHint) return;
      preferredDateHint.textContent = 'Bookings need at least ' + leadDays + ' days’ notice. Earliest available: ' + formatLongDate(getMinDate()) + '.';
    };

    const showPreferredDateError = function () {
      if (!preferredDateError) return;
      preferredDateError.textContent = 'That date is within ' + leadDays + ' days. Please choose ' + formatLongDate(getMinDate()) + ' or later.';
      preferredDateError.hidden = false;
    };

    const hidePreferredDateError = function () {
      if (preferredDateError) preferredDateError.hidden = true;
    };

    const enforcePreferredDate = function () {
      if (!preferredDateInput) return;
      const v = preferredDateInput.value;
      if (v && v < getMinIso()) {
        preferredDateInput.value = '';
        state.patient.preferredDate = '';
        showPreferredDateError();
      } else {
        hidePreferredDateError();
      }
    };

    const fieldInputs = root.querySelectorAll('[data-cmb-field]');
    fieldInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        state.patient[input.dataset.cmbField] = input.value.trim();
        if (input === preferredDateInput) enforcePreferredDate();
        updateNextEnabled();
      });
    });

    if (preferredDateInput) {
      preferredDateInput.setAttribute('min', getMinIso());
      refreshPreferredDateHint();
      preferredDateInput.addEventListener('change', function () {
        enforcePreferredDate();
        updateNextEnabled();
      });
      preferredDateInput.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' || e.key === 'Escape') return;
        e.preventDefault();
      });
      preferredDateInput.addEventListener('paste', function (e) { e.preventDefault(); });
      preferredDateInput.addEventListener('drop', function (e) { e.preventDefault(); });

      const openPicker = function () {
        preferredDateInput.setAttribute('min', getMinIso());
        refreshPreferredDateHint();
        if (typeof preferredDateInput.showPicker === 'function') {
          try { preferredDateInput.showPicker(); } catch (e) {}
        }
      };
      preferredDateInput.addEventListener('click', openPicker);
      preferredDateInput.addEventListener('focus', openPicker);
    }

    const pillInputs = root.querySelectorAll('[data-cmb-pill]');
    pillInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          state.patient[input.dataset.cmbPill] = input.value;
          updateNextEnabled();
        }
      });
    });

    triggerBtns.forEach(function (b) { b.addEventListener('click', openOverlay); });
    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    backBtn.addEventListener('click', function () { goToStep(state.step - 1); });
    nextBtn.addEventListener('click', function () {
      if (
        state.step === 1 &&
        state.scanType === 'partBody' &&
        state.partBodyChoice === 'partBody2' &&
        !state.parts[1]
      ) {
        showStep1Error();
        return;
      }
      if (state.step === 4) submitBooking();
      else goToStep(state.step + 1);
    });

    addonBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.cmbAddon;
        state.addons[key] = !state.addons[key];
        btn.classList.toggle('is-selected', state.addons[key]);
        btn.setAttribute('aria-pressed', state.addons[key] ? 'true' : 'false');
        renderTotal();
        applyLocationFilter();
        // Drop the location pick if the new package is no longer supported there.
        if (state.location && state.addons.heart && !state.location.supportsHeart) {
          state.location = null;
          if (locationsList) locationsList.querySelectorAll('.cmb__location.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
        }
        updateNextEnabled();
      });
    });

    // Scan-type toggle (Part Body vs Full Body). Only present when both are offered.
    const scanTabs = root.querySelectorAll('[data-cmb-scan-tab]');
    const groupPartBody = root.querySelector('[data-cmb-group="partBody"]');
    const groupFullBody = root.querySelector('[data-cmb-group="fullBody"]');
    function applyScanType() {
      scanTabs.forEach(function (t) {
        const match = t.dataset.cmbScanTab === state.scanType;
        t.classList.toggle('is-active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
      });
      if (groupPartBody) groupPartBody.hidden = state.scanType !== 'partBody';
      if (groupFullBody) groupFullBody.hidden = state.scanType !== 'fullBody';
      // Hide / re-evaluate the Part Body picker when scan type changes.
      showPartBodyPicker();
      // Clear the location pick when scan type changes — different services may have different clinics.
      if (state.location) {
        state.location = null;
        if (locationsList) locationsList.querySelectorAll('.cmb__location.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
      }
      renderTotal();
      applyLocationFilter();
      updateNextEnabled();
    }
    scanTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (state.scanType === tab.dataset.cmbScanTab) return;
        state.scanType = tab.dataset.cmbScanTab;
        hideStep1Error();
        if (state.scanType === 'partBody') {
          // Part Body has no add-ons.
          state.addons.heart = false;
          state.addons.prostate = false;
          addonBtns.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
        } else {
          // Switching to Full Body clears any Part Body choice + selected parts.
          state.partBodyChoice = null;
          state.parts = [null, null];
          partBodyBtns.forEach(function (b) {
            b.classList.remove('is-selected');
            b.setAttribute('aria-pressed', 'false');
          });
        }
        applyScanType();
      });
    });

    // Part Body package selection (radio-style — only one can be picked).
    const partBodyBtns = root.querySelectorAll('[data-cmb-package]');
    partBodyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.cmbPackage;
        state.partBodyChoice = state.partBodyChoice === key ? null : key;
        partBodyBtns.forEach(function (b) {
          const isSelected = b.dataset.cmbPackage === state.partBodyChoice;
          b.classList.toggle('is-selected', isSelected);
          b.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
        hideStep1Error();
        showPartBodyPicker();
        renderTotal();
        updateNextEnabled();
      });
    });

    // === Part Body picker (SVG body diagram + search/chip/results) ===
    let pickerInited = { 1: false, 2: false };

    function showPartBodyPicker() {
      if (!partBodyPickerWrap || !partBodyData) return;
      if (state.scanType !== 'partBody' || !state.partBodyChoice) {
        partBodyPickerWrap.hidden = true;
        return;
      }
      partBodyPickerWrap.hidden = false;
      if (!pickerInited[1]) {
        initPicker(1);
        pickerInited[1] = true;
      }
      // 1-area: hide second picker + "add second" CTA. Clear parts[1].
      if (state.partBodyChoice === 'partBody1') {
        if (addSecondCta) addSecondCta.hidden = true;
        if (removeSecondWrap) removeSecondWrap.hidden = true;
        const sec = root.querySelector('[data-cmb-picker="2"]');
        if (sec) sec.remove();
        pickerInited[2] = false;
        state.parts[1] = null;
        state.partsUi[1] = { region: 'all', side: 'all', query: '' };
      } else if (state.partBodyChoice === 'partBody2') {
        // Show "add second" CTA only when the second picker isn't mounted yet.
        if (addSecondCta) addSecondCta.hidden = pickerInited[2];
        if (removeSecondWrap) removeSecondWrap.hidden = !pickerInited[2];
      }
    }

    if (addSecondBtn) {
      addSecondBtn.addEventListener('click', function () {
        mountSecondPicker();
        if (addSecondCta) addSecondCta.hidden = true;
        if (removeSecondWrap) removeSecondWrap.hidden = false;
        hideStep1Error();
      });
    }

    if (removeSecondBtn) {
      removeSecondBtn.addEventListener('click', function () {
        state.parts[1] = null;
        state.partsUi[1] = { region: 'all', side: 'all', query: '' };
        const sec = root.querySelector('[data-cmb-picker="2"]');
        if (sec) sec.remove();
        pickerInited[2] = false;
        if (addSecondCta) addSecondCta.hidden = false;
        if (removeSecondWrap) removeSecondWrap.hidden = true;
        hideStep1Error();
        renderTotal();
        updateNextEnabled();
      });
    }

    function mountSecondPicker() {
      const tmpl = root.querySelector('[data-cmb-picker-template="2"]');
      if (!tmpl || !tmpl.content || !pickersWrap) return;
      const node = tmpl.content.firstElementChild.cloneNode(true);
      pickersWrap.appendChild(node);
      initPicker(2);
      pickerInited[2] = true;
    }

    function initPicker(slot) {
      if (!partBodyData) return;
      const pickerEl = root.querySelector('[data-cmb-picker="' + slot + '"]');
      if (!pickerEl) return;
      const idx = slot - 1;
      const search = pickerEl.querySelector('[data-cmb-search="' + slot + '"]');
      const chipsWrap = pickerEl.querySelector('[data-cmb-chips="' + slot + '"]');
      const results = pickerEl.querySelector('[data-cmb-results="' + slot + '"]');
      const titleEl = pickerEl.querySelector('[data-cmb-results-title="' + slot + '"]');
      const countEl = pickerEl.querySelector('[data-cmb-count="' + slot + '"]');
      const viewBtns = pickerEl.querySelectorAll('[data-cmb-view]');
      const svgs = pickerEl.querySelectorAll('.cmb__svg');
      const zones = pickerEl.querySelectorAll('.cmb__zone');

      chipsWrap.innerHTML = '';
      partBodyData.regions.forEach(function (r) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cmb__chip';
        btn.dataset.region = r.id;
        btn.textContent = r.label;
        if (r.id === state.partsUi[idx].region) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          state.partsUi[idx].region = r.id;
          state.partsUi[idx].side = 'all';
          state.partsUi[idx].query = '';
          search.value = '';
          clearZoneActive();
          render();
        });
        chipsWrap.appendChild(btn);
      });

      search.addEventListener('input', function () {
        state.partsUi[idx].query = search.value.trim().toLowerCase();
        if (state.partsUi[idx].query) {
          state.partsUi[idx].region = 'all';
          state.partsUi[idx].side = 'all';
          clearZoneActive();
        }
        render();
      });

      viewBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const view = btn.dataset.cmbView;
          viewBtns.forEach(function (b) {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          svgs.forEach(function (svg) {
            svg.classList.toggle('is-active', svg.classList.contains('cmb__svg--' + view));
          });
        });
      });

      zones.forEach(function (zone) {
        zone.addEventListener('click', function () { activateZone(zone); });
        zone.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateZone(zone);
          }
        });
      });

      function activateZone(node) {
        const id = node.dataset.region;
        const targetRegion = (partBodyData.regionMap && partBodyData.regionMap[id]) || 'all';
        const targetSide = (partBodyData.regionSide && partBodyData.regionSide[id]) || 'all';
        clearZoneActive();
        node.classList.add('is-active');
        state.partsUi[idx].region = targetRegion;
        state.partsUi[idx].side = targetSide;
        state.partsUi[idx].query = '';
        search.value = '';
        render();

        if (window.matchMedia && window.matchMedia('(max-width: 880px)').matches) {
          const target = pickerEl.querySelector('.cmb__results-meta') || pickerEl.querySelector('.cmb__picker-controls');
          if (target) {
            window.requestAnimationFrame(function () {
              try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
              catch (e) { target.scrollIntoView(); }
            });
          }
        }
      }

      function clearZoneActive() {
        zones.forEach(function (z) { z.classList.remove('is-active'); });
      }

      function render() {
        const ui = state.partsUi[idx];
        const filtered = partBodyData.parts.filter(function (p) {
          if (ui.region !== 'all' && p.region !== ui.region) return false;
          if (ui.side && ui.side !== 'all' && p.side !== 'all' && p.side !== ui.side) return false;
          if (ui.query) {
            const hay = (p.name + ' ' + (p.kw || '')).toLowerCase();
            if (hay.indexOf(ui.query) === -1) return false;
          }
          return true;
        });

        countEl.textContent = filtered.length + (filtered.length === 1 ? ' scan' : ' scans');
        const r = partBodyData.regions.find(function (x) { return x.id === ui.region; });
        let title = ui.region === 'all' && !ui.query ? 'All scans' : (r ? r.label + ' scans' : 'Scans');
        if (ui.side === 'left') title += ' · Left side';
        else if (ui.side === 'right') title += ' · Right side';
        titleEl.textContent = title;

        chipsWrap.querySelectorAll('.cmb__chip').forEach(function (c) {
          c.classList.toggle('is-active', c.dataset.region === ui.region);
        });

        results.innerHTML = '';
        filtered.forEach(function (p) {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cmb__result';
          let sideTag = '';
          if (p.side === 'left') sideTag = '<span class="cmb__side-tag">L</span>';
          else if (p.side === 'right') sideTag = '<span class="cmb__side-tag">R</span>';
          btn.innerHTML = '<span class="cmb__result-radio" aria-hidden="true"></span><span class="cmb__result-name">' + escapeHtml(p.name) + '</span>' + sideTag;
          const cur = state.parts[idx];
          if (cur && cur.name === p.name) btn.classList.add('is-selected');
          btn.addEventListener('click', function () {
            state.parts[idx] = { name: p.name, label: p.name + (p.side === 'left' ? ' (Left)' : p.side === 'right' ? ' (Right)' : '') };
            results.querySelectorAll('.cmb__result').forEach(function (rEl) { rEl.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            if (idx === 1) hideStep1Error();
            renderTotal();
            updateNextEnabled();
          });
          li.appendChild(btn);
          results.appendChild(li);
        });
      }

      render();
    }

    const locationButtons = root.querySelectorAll('[data-cmb-location]');
    locationButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        locationButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.location = {
          name: btn.dataset.name,
          address: btn.dataset.address,
          postcode: btn.dataset.postcode,
          handle: btn.dataset.handle,
          supportsHeart: btn.dataset.supportsHeart === '1'
        };
        updateNextEnabled();
      });
    });

    const postcodeStatus = root.querySelector('[data-cmb-postcode-status]');
    const originalLocationOrder = locationsList ? Array.from(locationsList.children) : [];
    let postcodeDebounce = null;
    let postcodeRequestId = 0;

    function setPostcodeStatus(message, kind) {
      if (!postcodeStatus) return;
      postcodeStatus.classList.remove('is-error', 'is-loading');
      if (!message) {
        postcodeStatus.hidden = true;
        postcodeStatus.textContent = '';
        return;
      }
      postcodeStatus.hidden = false;
      postcodeStatus.textContent = message;
      if (kind) postcodeStatus.classList.add('is-' + kind);
    }

    function clearLocationDistances() {
      root.querySelectorAll('[data-cmb-distance]').forEach(function (el) { el.textContent = ''; });
    }

    function restoreOriginalLocationOrder() {
      if (!locationsList) return;
      originalLocationOrder.forEach(function (li) { locationsList.appendChild(li); });
    }

    function distanceMiles(lat1, lng1, lat2, lng2) {
      const R = 3958.8;
      const toRad = function (d) { return d * Math.PI / 180; };
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function sortLocationsByDistance(userLat, userLng) {
      if (!locationsList) return;
      const items = Array.from(locationsList.querySelectorAll('li')).map(function (li) {
        const btn = li.querySelector('[data-cmb-location]');
        const lat = btn ? parseFloat(btn.dataset.lat) : NaN;
        const lng = btn ? parseFloat(btn.dataset.lng) : NaN;
        const ok = !isNaN(lat) && !isNaN(lng);
        return { li: li, btn: btn, distance: ok ? distanceMiles(userLat, userLng, lat, lng) : Infinity };
      });
      items.sort(function (a, b) { return a.distance - b.distance; });
      items.forEach(function (item) {
        locationsList.appendChild(item.li);
        const distEl = item.btn ? item.btn.querySelector('[data-cmb-distance]') : null;
        if (distEl) {
          if (isFinite(item.distance)) {
            const miles = item.distance < 10 ? item.distance.toFixed(1) : Math.round(item.distance).toString();
            distEl.textContent = miles + ' mi';
          } else {
            distEl.textContent = '';
          }
        }
      });
      try { locationsList.scrollTop = 0; } catch (e) {}
    }

    function lookupPostcode(raw) {
      const cleaned = raw.replace(/\s+/g, '').toUpperCase();
      if (cleaned.length < 2) {
        setPostcodeStatus('Enter at least an outcode (e.g. SW1A).', 'error');
        return;
      }
      const fullRe = /^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/;
      const outRe = /^[A-Z]{1,2}[0-9][A-Z0-9]?$/;
      let url;
      if (fullRe.test(cleaned)) {
        const m = cleaned.match(fullRe);
        url = 'https://api.postcodes.io/postcodes/' + encodeURIComponent(m[1] + ' ' + m[2]);
      } else if (outRe.test(cleaned)) {
        url = 'https://api.postcodes.io/outcodes/' + encodeURIComponent(cleaned);
      } else {
        setPostcodeStatus("That doesn't look like a UK postcode.", 'error');
        return;
      }

      const requestId = ++postcodeRequestId;
      setPostcodeStatus('Finding your closest clinic…', 'loading');

      fetch(url)
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (requestId !== postcodeRequestId) return;
          if (!res.ok || !res.body || res.body.status !== 200 || !res.body.result) {
            throw new Error('not-found');
          }
          const lat = parseFloat(res.body.result.latitude);
          const lng = parseFloat(res.body.result.longitude);
          if (isNaN(lat) || isNaN(lng)) throw new Error('no-coords');
          sortLocationsByDistance(lat, lng);
          setPostcodeStatus('Showing clinics nearest to ' + cleaned.replace(/^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/, '$1 $2') + ', closest first.');
        })
        .catch(function () {
          if (requestId !== postcodeRequestId) return;
          setPostcodeStatus("We couldn't find that postcode. Try a UK postcode like SW1A 1AA.", 'error');
        });
    }

    if (postcodeInput) {
      postcodeInput.addEventListener('input', function () {
        clearTimeout(postcodeDebounce);
        const v = postcodeInput.value.trim();
        if (!v) {
          postcodeRequestId++;
          restoreOriginalLocationOrder();
          clearLocationDistances();
          setPostcodeStatus('');
          return;
        }
        postcodeDebounce = setTimeout(function () { lookupPostcode(v); }, 350);
      });
    }

    function applyLocationFilter() {
      if (!locationsList) return;
      const isPartBody = state.scanType === 'partBody';
      const heartRequired = !isPartBody && state.addons.heart;
      let visible = 0;
      locationsList.querySelectorAll('[data-cmb-location-li]').forEach(function (li) {
        const supportsPartBody = li.dataset.supportsPartBody === '1';
        const supportsBase = li.dataset.supportsBase === '1';
        const supportsHeart = li.dataset.supportsHeart === '1';
        let show;
        if (isPartBody) {
          show = supportsPartBody;
        } else if (heartRequired) {
          show = supportsHeart;
        } else {
          show = supportsBase;
        }
        li.hidden = !show;
        if (show) visible++;
      });

      if (locationIntro) {
        if (isPartBody) {
          locationIntro.textContent = 'Showing clinics that can perform a Part Body MRI scan.';
        } else if (heartRequired) {
          locationIntro.textContent = 'Showing clinics that can perform a Full Body MRI with Cardiac upgrade.';
        } else {
          locationIntro.textContent = 'Showing clinics that can perform your Full Body MRI scan.';
        }
      }

      if (locationsNoHeart) locationsNoHeart.hidden = !(heartRequired && visible === 0);
      if (locationsEmpty) locationsEmpty.hidden = visible !== 0 || (heartRequired && visible === 0);
    }

    renderTotal();
    applyLocationFilter();
    showPartBodyPicker();
    updateNextEnabled();
    renderSteps();

    // ── Abandonment capture ────────────────────────────────────────────────
    // Sends a JSON beacon to a Google Apps Script web app when the user closes
    // the overlay or leaves the page with partial booking data, so customer
    // service can follow up. One beacon per overlay-open session.
    const abandonmentUrl = root.dataset.abandonmentUrl || '';
    const flowId = root.dataset.flowId || 'clinic-hybrid';
    let sessionId = '';
    let hasSentLead = false;

    function newSessionId() {
      try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
      return 'sid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function hasPartialPatientData() {
      return !!state.patient.phone;
    }

    function maybeSendLead() {
      if (!abandonmentUrl || hasSentLead) return;
      if (!hasPartialPatientData()) return;
      hasSentLead = true;
      const p = state.patient;
      const addons = [];
      if (state.addons.heart) addons.push('cardiac');
      if (state.addons.prostate) addons.push('prostate');
      const payload = {
        session_id: sessionId,
        flow: flowId,
        step_reached: state.step,
        first_name: p.firstName || '',
        last_name: p.lastName || '',
        phone: p.phone || '',
        dob: p.dob || '',
        gender: p.gender || '',
        preferred_date: p.preferredDate || '',
        time_preference: p.timePreference || '',
        pacemaker: p.pacemaker || '',
        clinical_reason: p.clinicalReason || '',
        body_part_1: (state.parts[0] && state.parts[0].name) || '',
        body_part_2: (state.parts[1] && state.parts[1].name) || '',
        scan_type: state.scanType || '',
        addons: addons.join(','),
        location: state.location ? state.location.name : '',
        client_timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent || ''
      };
      try {
        const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon) navigator.sendBeacon(abandonmentUrl, blob);
        else fetch(abandonmentUrl, { method: 'POST', body: blob, keepalive: true, mode: 'no-cors' }).catch(function () {});
      } catch (e) {}
    }

    window.addEventListener('pagehide', maybeSendLead);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') maybeSendLead();
    });

    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      sessionId = newSessionId();
      hasSentLead = false;
    }

    function closeOverlay() {
      maybeSendLead();
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function goToStep(n) {
      if (n < 1) n = 1;
      if (n > 4) n = 4;
      if (n === state.step) return;
      if (n > state.step && !canAdvanceFrom(state.step)) return;
      if (state.step === 1) hideStep1Error();
      state.step = n;
      renderSteps();
      if (n === 4) renderSummary();
      const main = root.querySelector('.cmb__overlay-inner');
      if (main) main.scrollTop = 0;
      try { overlay.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    function canAdvanceFrom(s) {
      if (s === 1) {
        // Must have a concrete choice when on Part Body, plus the first part.
        if (state.scanType === 'partBody') {
          if (!state.partBodyChoice) return false;
          if (!state.parts[0]) return false;
          // Note: an empty second slot doesn't disable the button — the click handler
          // surfaces an inline error instead, so the user sees *why* they can't continue.
        }
        return true;
      }
      if (s === 2) return !!state.location;
      if (s === 3) {
        const p = state.patient;
        if (!(p.firstName && p.lastName && p.phone && p.dob && p.gender && p.preferredDate && p.timePreference && p.pacemaker && p.clinicalReason)) return false;
        if (state.scanType !== 'partBody' && state.addons.prostate && p.gender !== 'Male') return false;
        return p.preferredDate >= getMinIso();
      }
      return true;
    }

    function renderSteps() {
      stepTabs.forEach(function (t) {
        const i = parseInt(t.dataset.cmbStepTab, 10);
        t.classList.toggle('is-active', i === state.step);
        t.classList.toggle('is-complete', i < state.step);
      });
      panels.forEach(function (p) {
        const i = parseInt(p.dataset.cmbPanel, 10);
        const active = i === state.step;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
      backBtn.hidden = state.step === 1;
      if (nextLabel) nextLabel.textContent = state.step === 4 ? 'Confirm & continue to payment' : 'Continue';
      updateNextEnabled();
    }

    function updateNextEnabled() {
      nextBtn.disabled = !canAdvanceFrom(state.step);
    }

    function packageLabel() {
      if (state.scanType === 'partBody') {
        if (state.partBodyChoice === 'partBody1') {
          const a = state.parts[0] ? (state.parts[0].label || state.parts[0].name) : null;
          return 'Part Body MRI — 1 area' + (a ? ': ' + a : '');
        }
        if (state.partBodyChoice === 'partBody2') {
          const a = state.parts[0] ? (state.parts[0].label || state.parts[0].name) : null;
          const b = state.parts[1] ? (state.parts[1].label || state.parts[1].name) : null;
          if (a && b) return 'Part Body MRI — 2 areas: ' + a + ' + ' + b;
          if (a) return 'Part Body MRI — 2 areas: ' + a;
          return 'Part Body MRI — 2 areas';
        }
        return 'Part Body MRI';
      }
      const parts = ['Full Body MRI Scan'];
      if (state.addons.heart) parts.push('Cardiac upgrade');
      if (state.addons.prostate) parts.push('Prostate screening');
      return parts.join(' + ');
    }

    function packageTotal() {
      // For Part Body we don't compute a numeric total — pricing is variant-driven.
      // Returning null lets renderTotal show the section-settings price label instead.
      if (state.scanType === 'partBody') return null;
      let t = PRICES.base;
      if (state.addons.heart) t += PRICES.heart;
      if (state.addons.prostate) t += PRICES.prostate;
      return t;
    }

    function formatGBP(n) {
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(n);
      } catch (e) {
        return '£' + n.toLocaleString();
      }
    }

    function renderTotal() {
      if (totalSummary) totalSummary.textContent = packageLabel();
      const t = packageTotal();
      let priceText;
      if (t == null) {
        // Show the chosen package's price label, falling back to a generic.
        let label = '';
        if (state.partBodyChoice === 'partBody1') {
          const btn = root.querySelector('[data-cmb-package="partBody1"] .cmb__package-price');
          if (btn) label = btn.textContent;
        } else if (state.partBodyChoice === 'partBody2') {
          const btn = root.querySelector('[data-cmb-package="partBody2"] .cmb__package-price');
          if (btn) label = btn.textContent;
        }
        priceText = label || '—';
      } else {
        priceText = formatGBP(t);
      }
      if (totalPrice) totalPrice.textContent = priceText;
      if (footerTotalValue) footerTotalValue.textContent = priceText;
    }

    function renderSummary() {
      const rows = [];
      const pTotal = packageTotal();
      const priceSmall = pTotal == null ? '' : '<small>' + formatGBP(pTotal) + '</small>';
      rows.push(summaryRow('Package', packageLabel() + priceSmall, 1, true));
      if (state.scanType === 'partBody') {
        if (state.parts[0]) rows.push(summaryRow('Body part 1', state.parts[0].label || state.parts[0].name, 1));
        if (state.partBodyChoice === 'partBody2' && state.parts[1]) {
          rows.push(summaryRow('Body part 2', state.parts[1].label || state.parts[1].name, 1));
        }
      }
      if (state.location) {
        const addr = state.location.address || '';
        rows.push(summaryRow('Clinic', state.location.name + (addr ? '<small>' + escapeHtml(addr) + '</small>' : ''), 2, true));
      }
      const p = state.patient;
      const fullName = (p.firstName + ' ' + p.lastName).trim();
      if (fullName) rows.push(summaryRow('Patient', fullName + (p.dob ? '<small>DOB ' + escapeHtml(formatDate(p.dob)) + (p.gender ? ' · ' + escapeHtml(p.gender) : '') + '</small>' : ''), 3, true));
      if (p.phone) rows.push(summaryRow('Phone', p.phone, 3));
      if (p.preferredDate) rows.push(summaryRow('Appointment', formatDate(p.preferredDate) + (p.timePreference ? '<small>' + escapeHtml(p.timePreference) + '</small>' : ''), 3, true));
      if (p.pacemaker) rows.push(summaryRow('Pace-maker fitted', p.pacemaker, 3));
      if (p.clinicalReason) rows.push(summaryRow('Clinical reason', p.clinicalReason, 3));
      summaryEl.innerHTML = rows.join('');

      summaryEl.querySelectorAll('[data-edit-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          goToStep(parseInt(b.dataset.editStep, 10));
        });
      });
    }

    function formatDate(iso) {
      if (!iso) return '';
      const parts = iso.split('-');
      if (parts.length !== 3) return iso;
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    function summaryRow(label, value, step, allowHtml) {
      const valueHtml = allowHtml ? value : escapeHtml(value);
      return '<div class="cmb__summary-row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd><button type="button" class="cmb__summary-edit" data-edit-step="' + step + '">Change</button></div>';
    }

    function pickVariantId() {
      if (state.scanType === 'partBody') {
        if (state.partBodyChoice === 'partBody1') return variants.partBody1;
        if (state.partBodyChoice === 'partBody2') return variants.partBody2;
        return '';
      }
      if (state.addons.heart && state.addons.prostate) return variants.heartProstate || variants.heart || variants.base;
      if (state.addons.heart) return variants.heart || variants.base;
      if (state.addons.prostate) return variants.prostate || variants.base;
      return variants.base;
    }

    function submitBooking() {
      errorEl.hidden = true;
      const variantId = pickVariantId();
      if (!variantId) {
        showError('No variant configured. Set the variant IDs in the section settings.');
        return;
      }

      loadingEl.hidden = false;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('properties[Package]', packageLabel());
      if (state.scanType === 'partBody') {
        if (state.parts[0]) formData.append('properties[Body part 1]', state.parts[0].label || state.parts[0].name);
        if (state.partBodyChoice === 'partBody2' && state.parts[1]) {
          formData.append('properties[Body part 2]', state.parts[1].label || state.parts[1].name);
        }
      } else {
        formData.append('properties[Cardiac upgrade]', state.addons.heart ? 'Yes' : 'No');
        formData.append('properties[Prostate screening]', state.addons.prostate ? 'Yes' : 'No');
      }
      if (state.location) {
        formData.append('properties[Clinic]', state.location.name);
        if (state.location.address) formData.append('properties[Clinic address]', state.location.address);
      }
      const p = state.patient;
      if (p.firstName) formData.append('properties[Patient first name]', p.firstName);
      if (p.lastName) formData.append('properties[Patient last name]', p.lastName);
      if (p.phone) formData.append('properties[Patient phone]', p.phone);
      if (p.dob) formData.append('properties[Patient DOB]', formatDate(p.dob));
      if (p.gender) formData.append('properties[Gender]', p.gender);
      if (p.preferredDate) formData.append('properties[Preferred appointment date]', formatDate(p.preferredDate));
      if (p.timePreference) formData.append('properties[Time preference]', p.timePreference);
      if (p.pacemaker) formData.append('properties[Pace-maker fitted]', p.pacemaker);
      if (p.clinicalReason) formData.append('properties[Clinical reason for scan]', p.clinicalReason);

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          // Note: we intentionally DO NOT suppress the abandonment beacon here.
          // Reaching Shopify checkout != completing payment. If the user bails
          // at the Shopify checkout, they're a valid lead. Staff dedupe by
          // phone against placed orders before calling.
          const url = root.dataset.checkoutUrl || '/checkout';
          window.location.href = url;
        })
        .catch(function (err) {
          loadingEl.hidden = true;
          showError(err.message || 'Could not add to cart. Please try again.');
        });
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mri-booking-flow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-mbf-section]:not([data-mbf-init])');
  sections.forEach(initBookingFlow);

  function initBookingFlow(root) {
    root.setAttribute('data-mbf-init', '1');
    const dataEl = root.querySelector('[data-mbf-data]');
    if (!dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const overlay = root.querySelector('[data-mbf-overlay]');
    const triggerBtns = root.querySelectorAll('[data-mbf-open]');
    const closeBtn = root.querySelector('[data-mbf-close]');
    const backBtn = root.querySelector('[data-mbf-back]');
    const nextBtn = root.querySelector('[data-mbf-next]');
    const nextLabel = root.querySelector('[data-mbf-next-label]');
    const stepTabs = root.querySelectorAll('[data-mbf-step-tab]');
    const panels = root.querySelectorAll('[data-mbf-panel]');
    const pickersWrap = root.querySelector('[data-mbf-pickers]');
    const addSecondBtn = root.querySelector('[data-mbf-add-second]');
    const removeSecondWrap = root.querySelector('[data-mbf-remove-second]');
    const removeSecondBtn = root.querySelector('[data-mbf-remove-second-btn]');
    const summaryEl = root.querySelector('[data-mbf-summary]');
    const errorEl = root.querySelector('[data-mbf-error]');
    const step1ErrorEl = root.querySelector('[data-mbf-step1-error]');

    function showStep1Error() {
      if (!step1ErrorEl) return;
      step1ErrorEl.hidden = false;
      try { step1ErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    }
    function hideStep1Error() {
      if (step1ErrorEl) step1ErrorEl.hidden = true;
    }
    const loadingEl = root.querySelector('[data-mbf-loading]');
    const postcodeInput = root.querySelector('[data-mbf-postcode]');
    const locationsList = root.querySelector('[data-mbf-locations]');
    const locationsEmpty = root.querySelector('[data-mbf-locations-empty]');
    const locationButtons = root.querySelectorAll('[data-mbf-location]');

    const state = {
      step: 1,
      first: { selected: null, region: 'all', side: 'all', query: '' },
      second: { selected: null, region: 'all', side: 'all', query: '', enabled: false },
      location: null,
      patient: {
        firstName: '',
        lastName: '',
        phone: '',
        dob: '',
        gender: '',
        preferredDate: '',
        timePreference: '',
        pacemaker: '',
        clinicalReason: ''
      }
    };

    const leadDays = parseInt(root.dataset.minLeadDays || '10', 10) || 10;
    const getMinDate = function () {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + leadDays);
      return d;
    };
    const toIso = function (d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd;
    };
    const getMinIso = function () { return toIso(getMinDate()); };
    const dateLabelFmt = (function () {
      try {
        return new Intl.DateTimeFormat(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) { return null; }
    })();
    const formatLongDate = function (d) {
      return dateLabelFmt ? dateLabelFmt.format(d) : toIso(d);
    };

    const preferredDateInput = root.querySelector('[data-mbf-field="preferredDate"]');
    const preferredDateHint = root.querySelector('[data-mbf-pd-hint]');
    const preferredDateError = root.querySelector('[data-mbf-pd-error]');

    const refreshPreferredDateHint = function () {
      if (!preferredDateHint) return;
      preferredDateHint.textContent = 'Bookings need at least ' + leadDays + ' days’ notice. Earliest available: ' + formatLongDate(getMinDate()) + '.';
    };

    const showPreferredDateError = function () {
      if (!preferredDateError) return;
      preferredDateError.textContent = 'That date is within ' + leadDays + ' days. Please choose ' + formatLongDate(getMinDate()) + ' or later.';
      preferredDateError.hidden = false;
    };

    const hidePreferredDateError = function () {
      if (preferredDateError) preferredDateError.hidden = true;
    };

    // iOS Safari's native date picker doesn't visually disable dates before
    // `min` and doesn't always fire `change` after dismissal — validate on
    // every input event and gate advancement in canAdvanceFrom.
    const enforcePreferredDate = function () {
      if (!preferredDateInput) return;
      const v = preferredDateInput.value;
      if (v && v < getMinIso()) {
        preferredDateInput.value = '';
        state.patient.preferredDate = '';
        showPreferredDateError();
      } else {
        hidePreferredDateError();
      }
    };

    const fieldInputs = root.querySelectorAll('[data-mbf-field]');
    fieldInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        state.patient[input.dataset.mbfField] = input.value.trim();
        if (input === preferredDateInput) enforcePreferredDate();
        updateNextEnabled();
      });
    });

    if (preferredDateInput) {
      preferredDateInput.setAttribute('min', getMinIso());
      refreshPreferredDateHint();
      preferredDateInput.addEventListener('change', function () {
        enforcePreferredDate();
        updateNextEnabled();
      });

      // Block typing & pasting; only the picker can set a value.
      preferredDateInput.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' || e.key === 'Escape') return;
        e.preventDefault();
      });
      preferredDateInput.addEventListener('paste', function (e) { e.preventDefault(); });
      preferredDateInput.addEventListener('drop', function (e) { e.preventDefault(); });

      const openPicker = function () {
        // Refresh min in case the form has been open across midnight.
        preferredDateInput.setAttribute('min', getMinIso());
        refreshPreferredDateHint();
        if (typeof preferredDateInput.showPicker === 'function') {
          try { preferredDateInput.showPicker(); } catch (e) {}
        }
      };
      preferredDateInput.addEventListener('click', openPicker);
      preferredDateInput.addEventListener('focus', openPicker);
    }

    const pillInputs = root.querySelectorAll('[data-mbf-pill]');
    pillInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          state.patient[input.dataset.mbfPill] = input.value;
          updateNextEnabled();
        }
      });
    });

    triggerBtns.forEach(function (b) { b.addEventListener('click', openOverlay); });
    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    backBtn.addEventListener('click', function () { goToStep(state.step - 1); });
    nextBtn.addEventListener('click', function () {
      if (state.step === 1 && state.second.enabled && !state.second.selected) {
        showStep1Error();
        return;
      }
      if (state.step === 4) submitBooking();
      else goToStep(state.step + 1);
    });

    initPicker(1);

    addSecondBtn.addEventListener('click', function () {
      state.second.enabled = true;
      mountSecondPicker();
      addSecondBtn.parentElement.hidden = true;
      removeSecondWrap.hidden = false;
      hideStep1Error();
      renderTotal();
    });

    removeSecondBtn.addEventListener('click', function () {
      state.second.enabled = false;
      state.second.selected = null;
      const sec = root.querySelector('[data-mbf-picker="2"]');
      if (sec) sec.remove();
      addSecondBtn.parentElement.hidden = false;
      removeSecondWrap.hidden = true;
      hideStep1Error();
      renderTotal();
      updateNextEnabled();
    });

    locationButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        locationButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.location = {
          name: btn.dataset.name,
          address: btn.dataset.address,
          postcode: btn.dataset.postcode,
          phone: btn.dataset.phone
        };
        updateNextEnabled();
      });
    });

    const postcodeStatus = root.querySelector('[data-mbf-postcode-status]');
    const originalLocationOrder = locationsList ? Array.from(locationsList.children) : [];
    let postcodeDebounce = null;
    let postcodeRequestId = 0;

    function setPostcodeStatus(message, kind) {
      if (!postcodeStatus) return;
      postcodeStatus.classList.remove('is-error', 'is-loading');
      if (!message) {
        postcodeStatus.hidden = true;
        postcodeStatus.textContent = '';
        return;
      }
      postcodeStatus.hidden = false;
      postcodeStatus.textContent = message;
      if (kind) postcodeStatus.classList.add('is-' + kind);
    }

    function clearLocationDistances() {
      root.querySelectorAll('[data-mbf-distance]').forEach(function (el) { el.textContent = ''; });
    }

    function restoreOriginalLocationOrder() {
      if (!locationsList) return;
      originalLocationOrder.forEach(function (li) { locationsList.appendChild(li); });
    }

    function distanceMiles(lat1, lng1, lat2, lng2) {
      const R = 3958.8;
      const toRad = function (d) { return d * Math.PI / 180; };
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function sortLocationsByDistance(userLat, userLng) {
      if (!locationsList) return;
      const items = Array.from(locationsList.querySelectorAll('li')).map(function (li) {
        const btn = li.querySelector('[data-mbf-location]');
        const lat = btn ? parseFloat(btn.dataset.lat) : NaN;
        const lng = btn ? parseFloat(btn.dataset.lng) : NaN;
        const ok = !isNaN(lat) && !isNaN(lng);
        return { li: li, btn: btn, distance: ok ? distanceMiles(userLat, userLng, lat, lng) : Infinity };
      });
      items.sort(function (a, b) { return a.distance - b.distance; });
      items.forEach(function (item) {
        locationsList.appendChild(item.li);
        const distEl = item.btn ? item.btn.querySelector('[data-mbf-distance]') : null;
        if (distEl) {
          if (isFinite(item.distance)) {
            const miles = item.distance < 10 ? item.distance.toFixed(1) : Math.round(item.distance).toString();
            distEl.textContent = miles + ' mi';
          } else {
            distEl.textContent = '';
          }
        }
      });
      try { locationsList.scrollTop = 0; } catch (e) {}
    }

    function lookupPostcode(raw) {
      const cleaned = raw.replace(/\s+/g, '').toUpperCase();
      if (cleaned.length < 2) {
        setPostcodeStatus('Enter at least an outcode (e.g. SW1A).', 'error');
        return;
      }
      const fullRe = /^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/;
      const outRe = /^[A-Z]{1,2}[0-9][A-Z0-9]?$/;
      let url;
      if (fullRe.test(cleaned)) {
        const m = cleaned.match(fullRe);
        url = 'https://api.postcodes.io/postcodes/' + encodeURIComponent(m[1] + ' ' + m[2]);
      } else if (outRe.test(cleaned)) {
        url = 'https://api.postcodes.io/outcodes/' + encodeURIComponent(cleaned);
      } else {
        setPostcodeStatus("That doesn't look like a UK postcode.", 'error');
        return;
      }

      const requestId = ++postcodeRequestId;
      setPostcodeStatus('Finding your closest clinic…', 'loading');

      fetch(url)
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (requestId !== postcodeRequestId) return;
          if (!res.ok || !res.body || res.body.status !== 200 || !res.body.result) {
            throw new Error('not-found');
          }
          const lat = parseFloat(res.body.result.latitude);
          const lng = parseFloat(res.body.result.longitude);
          if (isNaN(lat) || isNaN(lng)) throw new Error('no-coords');
          sortLocationsByDistance(lat, lng);
          setPostcodeStatus('Showing clinics nearest to ' + cleaned.replace(/^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/, '$1 $2') + ', closest first.');
        })
        .catch(function () {
          if (requestId !== postcodeRequestId) return;
          setPostcodeStatus("We couldn't find that postcode. Try a UK postcode like SW1A 1AA.", 'error');
        });
    }

    if (postcodeInput) {
      postcodeInput.addEventListener('input', function () {
        clearTimeout(postcodeDebounce);
        const v = postcodeInput.value.trim();
        if (!v) {
          postcodeRequestId++;
          restoreOriginalLocationOrder();
          clearLocationDistances();
          setPostcodeStatus('');
          return;
        }
        postcodeDebounce = setTimeout(function () { lookupPostcode(v); }, 350);
      });
    }

    updateNextEnabled();
    renderSteps();

    // ── Abandonment capture ────────────────────────────────────────────────
    // Sends a JSON beacon to a Google Apps Script web app when the user closes
    // the overlay or leaves the page with partial booking data, so customer
    // service can follow up. One beacon per overlay-open session.
    const abandonmentUrl = root.dataset.abandonmentUrl || '';
    const flowId = root.dataset.flowId || 'part-mri';
    let sessionId = '';
    let hasSentLead = false;

    function newSessionId() {
      try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
      return 'sid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function hasPartialPatientData() {
      return !!state.patient.phone;
    }

    function maybeSendLead() {
      if (!abandonmentUrl || hasSentLead) return;
      if (!hasPartialPatientData()) return;
      hasSentLead = true;
      const p = state.patient;
      const payload = {
        session_id: sessionId,
        flow: flowId,
        step_reached: state.step,
        first_name: p.firstName || '',
        last_name: p.lastName || '',
        phone: p.phone || '',
        dob: p.dob || '',
        gender: p.gender || '',
        preferred_date: p.preferredDate || '',
        time_preference: p.timePreference || '',
        pacemaker: p.pacemaker || '',
        clinical_reason: p.clinicalReason || '',
        body_part_1: state.first.selected || '',
        body_part_2: (state.second.enabled && state.second.selected) || '',
        scan_type: 'partBody',
        addons: '',
        location: state.location ? state.location.name : '',
        client_timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent || ''
      };
      try {
        const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon) navigator.sendBeacon(abandonmentUrl, blob);
        else fetch(abandonmentUrl, { method: 'POST', body: blob, keepalive: true, mode: 'no-cors' }).catch(function () {});
      } catch (e) {}
    }

    window.addEventListener('pagehide', maybeSendLead);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') maybeSendLead();
    });

    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      sessionId = newSessionId();
      hasSentLead = false;
    }

    function closeOverlay() {
      maybeSendLead();
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function goToStep(n) {
      if (n < 1) n = 1;
      if (n > 4) n = 4;
      if (n === state.step) return;
      if (n > state.step && !canAdvanceFrom(state.step)) return;
      if (state.step === 1) hideStep1Error();
      state.step = n;
      renderSteps();
      if (n === 4) renderSummary();
      const main = root.querySelector('.mbf__overlay-inner');
      if (main) main.scrollTop = 0;
      try { overlay.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    function canAdvanceFrom(s) {
      if (s === 1) {
        if (!state.first.selected) return false;
        // Note: an empty second slot doesn't disable the button — the click handler
        // surfaces an inline error instead, so the user sees *why* they can't continue.
        return true;
      }
      if (s === 2) return !!state.location;
      if (s === 3) {
        const p = state.patient;
        if (!(p.firstName && p.lastName && p.phone && p.dob && p.gender && p.preferredDate && p.timePreference && p.pacemaker && p.clinicalReason)) return false;
        return p.preferredDate >= getMinIso();
      }
      return true;
    }

    function renderSteps() {
      stepTabs.forEach(function (t) {
        const i = parseInt(t.dataset.mbfStepTab, 10);
        t.classList.toggle('is-active', i === state.step);
        t.classList.toggle('is-complete', i < state.step);
      });
      panels.forEach(function (p) {
        const i = parseInt(p.dataset.mbfPanel, 10);
        const active = i === state.step;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
      backBtn.hidden = state.step === 1;
      if (nextLabel) nextLabel.textContent = state.step === 4 ? 'Confirm & continue to payment' : 'Continue';
      updateNextEnabled();
    }

    function updateNextEnabled() {
      nextBtn.disabled = !canAdvanceFrom(state.step);
    }

    const totalValueEl = root.querySelector('[data-mbf-total-value]');
    const onePartPriceLabel = root.dataset.onePartPrice || '';
    const twoPartPriceLabel = root.dataset.twoPartPrice || '';

    function renderTotal() {
      if (!totalValueEl) return;
      totalValueEl.textContent = state.second.enabled ? twoPartPriceLabel : onePartPriceLabel;
    }

    function mountSecondPicker() {
      const tmpl = root.querySelector('[data-mbf-picker-template="2"]');
      if (!tmpl || !tmpl.content) return;
      const node = tmpl.content.firstElementChild.cloneNode(true);
      pickersWrap.appendChild(node);
      initPicker(2);
    }

    function initPicker(slot) {
      const slotKey = slot === 1 ? 'first' : 'second';
      const pickerEl = root.querySelector('[data-mbf-picker="' + slot + '"]');
      const search = pickerEl.querySelector('[data-mbf-search="' + slot + '"]');
      const chipsWrap = pickerEl.querySelector('[data-mbf-chips="' + slot + '"]');
      const results = pickerEl.querySelector('[data-mbf-results="' + slot + '"]');
      const titleEl = pickerEl.querySelector('[data-mbf-results-title="' + slot + '"]');
      const countEl = pickerEl.querySelector('[data-mbf-count="' + slot + '"]');
      const viewBtns = pickerEl.querySelectorAll('[data-mbf-view]');
      const svgs = pickerEl.querySelectorAll('.mbf__svg');
      const zones = pickerEl.querySelectorAll('.mbf__zone');

      if (state[slotKey].side == null) state[slotKey].side = 'all';

      chipsWrap.innerHTML = '';
      data.regions.forEach(function (r) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mbf__chip';
        btn.dataset.region = r.id;
        btn.textContent = r.label;
        if (r.id === state[slotKey].region) btn.classList.add('is-active');
        btn.addEventListener('click', function () {
          state[slotKey].region = r.id;
          state[slotKey].side = 'all';
          state[slotKey].query = '';
          search.value = '';
          clearZoneActive();
          render();
        });
        chipsWrap.appendChild(btn);
      });

      search.addEventListener('input', function () {
        state[slotKey].query = search.value.trim().toLowerCase();
        if (state[slotKey].query) {
          state[slotKey].region = 'all';
          state[slotKey].side = 'all';
          clearZoneActive();
        }
        render();
      });

      viewBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const view = btn.dataset.mbfView;
          viewBtns.forEach(function (b) {
            const active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          svgs.forEach(function (svg) {
            svg.classList.toggle('is-active', svg.classList.contains('mbf__svg--' + view));
          });
        });
      });

      zones.forEach(function (zone) {
        zone.addEventListener('click', function () { activateZone(zone); });
        zone.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateZone(zone);
          }
        });
      });

      function activateZone(node) {
        const id = node.dataset.region;
        const targetRegion = (data.regionMap && data.regionMap[id]) || 'all';
        const targetSide = (data.regionSide && data.regionSide[id]) || 'all';
        clearZoneActive();
        node.classList.add('is-active');
        state[slotKey].region = targetRegion;
        state[slotKey].side = targetSide;
        state[slotKey].query = '';
        search.value = '';
        render();

        if (window.matchMedia && window.matchMedia('(max-width: 880px)').matches) {
          const target = pickerEl.querySelector('.mbf__results-meta') || pickerEl.querySelector('.mbf__picker-controls');
          if (target) {
            window.requestAnimationFrame(function () {
              try {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              } catch (e) {
                target.scrollIntoView();
              }
            });
          }
        }
      }

      function clearZoneActive() {
        zones.forEach(function (z) { z.classList.remove('is-active'); });
      }

      function render() {
        const filtered = data.parts.filter(function (p) {
          if (state[slotKey].region !== 'all' && p.region !== state[slotKey].region) return false;
          if (state[slotKey].side && state[slotKey].side !== 'all' && p.side !== 'all' && p.side !== state[slotKey].side) return false;
          if (state[slotKey].query) {
            const hay = (p.name + ' ' + (p.kw || '')).toLowerCase();
            if (hay.indexOf(state[slotKey].query) === -1) return false;
          }
          return true;
        });

        countEl.textContent = filtered.length + (filtered.length === 1 ? ' scan' : ' scans');
        const r = data.regions.find(function (x) { return x.id === state[slotKey].region; });
        let title = state[slotKey].region === 'all' && !state[slotKey].query ? 'All scans' : (r ? r.label + ' scans' : 'Scans');
        if (state[slotKey].side === 'left') title += ' · Left side';
        else if (state[slotKey].side === 'right') title += ' · Right side';
        titleEl.textContent = title;

        chipsWrap.querySelectorAll('.mbf__chip').forEach(function (c) {
          c.classList.toggle('is-active', c.dataset.region === state[slotKey].region);
        });

        results.innerHTML = '';
        filtered.forEach(function (p) {
          const li = document.createElement('li');
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mbf__result';
          let sideTag = '';
          if (p.side === 'left') sideTag = '<span class="mbf__side-tag">L</span>';
          else if (p.side === 'right') sideTag = '<span class="mbf__side-tag">R</span>';
          btn.innerHTML = '<span class="mbf__result-radio" aria-hidden="true"></span><span class="mbf__result-name">' + escapeHtml(p.name) + '</span>' + sideTag;
          if (state[slotKey].selected === p.name) btn.classList.add('is-selected');
          btn.addEventListener('click', function () {
            state[slotKey].selected = p.name;
            results.querySelectorAll('.mbf__result').forEach(function (r) { r.classList.remove('is-selected'); });
            btn.classList.add('is-selected');
            if (slot === 2) hideStep1Error();
            updateNextEnabled();
          });
          li.appendChild(btn);
          results.appendChild(li);
        });
      }

      render();
    }

    function renderSummary() {
      const rows = [];
      rows.push(summaryRow('Body part 1', state.first.selected || '—', 1));
      if (state.second.enabled && state.second.selected) {
        rows.push(summaryRow('Body part 2', state.second.selected, 1));
      }
      if (state.location) {
        const addr = state.location.address || '';
        rows.push(summaryRow('Clinic', state.location.name + (addr ? '<small>' + escapeHtml(addr) + '</small>' : ''), 2, true));
      }
      const p = state.patient;
      const fullName = (p.firstName + ' ' + p.lastName).trim();
      if (fullName) rows.push(summaryRow('Patient', fullName + (p.dob ? '<small>DOB ' + escapeHtml(formatDate(p.dob)) + (p.gender ? ' · ' + escapeHtml(p.gender) : '') + '</small>' : ''), 3, true));
      if (p.phone) rows.push(summaryRow('Phone', p.phone, 3));
      if (p.preferredDate) rows.push(summaryRow('Appointment', formatDate(p.preferredDate) + (p.timePreference ? '<small>' + escapeHtml(p.timePreference) + '</small>' : ''), 3, true));
      if (p.pacemaker) rows.push(summaryRow('Pace-maker fitted', p.pacemaker, 3));
      if (p.clinicalReason) rows.push(summaryRow('Clinical reason', p.clinicalReason, 3));
      summaryEl.innerHTML = rows.join('');

      summaryEl.querySelectorAll('[data-edit-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          goToStep(parseInt(b.dataset.editStep, 10));
        });
      });
    }

    function formatDate(iso) {
      if (!iso) return '';
      const parts = iso.split('-');
      if (parts.length !== 3) return iso;
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    function summaryRow(label, value, step, allowHtml) {
      const valueHtml = allowHtml ? value : escapeHtml(value);
      return '<div class="mbf__summary-row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd><button type="button" class="mbf__summary-edit" data-edit-step="' + step + '">Change</button></div>';
    }

    function submitBooking() {
      errorEl.hidden = true;
      const variantId = pickVariantId();
      if (!variantId) {
        showError('No variant configured. Set the variant IDs in the section settings.');
        return;
      }

      loadingEl.hidden = false;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('properties[Body part 1]', state.first.selected);
      if (state.second.enabled && state.second.selected) {
        formData.append('properties[Body part 2]', state.second.selected);
      }
      if (state.location) {
        formData.append('properties[Clinic]', state.location.name);
        if (state.location.address) formData.append('properties[Clinic address]', state.location.address);
      }
      const p = state.patient;
      if (p.firstName) formData.append('properties[Patient first name]', p.firstName);
      if (p.lastName) formData.append('properties[Patient last name]', p.lastName);
      if (p.phone) formData.append('properties[Patient phone]', p.phone);
      if (p.dob) formData.append('properties[Patient DOB]', formatDate(p.dob));
      if (p.gender) formData.append('properties[Gender]', p.gender);
      if (p.preferredDate) formData.append('properties[Preferred appointment date]', formatDate(p.preferredDate));
      if (p.timePreference) formData.append('properties[Time preference]', p.timePreference);
      if (p.pacemaker) formData.append('properties[Pace-maker fitted]', p.pacemaker);
      if (p.clinicalReason) formData.append('properties[Clinical reason for scan]', p.clinicalReason);

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          // Note: we intentionally DO NOT suppress the abandonment beacon here.
          // Reaching Shopify checkout != completing payment. If the user bails
          // at the Shopify checkout, they're a valid lead. Staff dedupe by
          // phone against placed orders before calling.
          const url = root.dataset.checkoutUrl || '/checkout';
          window.location.href = url;
        })
        .catch(function (err) {
          loadingEl.hidden = true;
          showError(err.message || 'Could not add to cart. Please try again.');
        });
    }

    function pickVariantId() {
      const oneId = root.dataset.onePartVariant;
      const twoId = root.dataset.twoPartVariant;
      const def = root.dataset.defaultVariant;
      if (state.second.enabled && state.second.selected) {
        return twoId || def || oneId;
      }
      return oneId || def || twoId;
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mri-full-body-booking-flow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-mfb-section]:not([data-mfb-init])');
  sections.forEach(initBookingFlow);

  function initBookingFlow(root) {
    root.setAttribute('data-mfb-init', '1');

    const overlay = root.querySelector('[data-mfb-overlay]');
    const triggerBtns = root.querySelectorAll('[data-mfb-open]');
    const closeBtn = root.querySelector('[data-mfb-close]');
    const backBtn = root.querySelector('[data-mfb-back]');
    const nextBtn = root.querySelector('[data-mfb-next]');
    const nextLabel = root.querySelector('[data-mfb-next-label]');
    const stepTabs = root.querySelectorAll('[data-mfb-step-tab]');
    const panels = root.querySelectorAll('[data-mfb-panel]');
    const summaryEl = root.querySelector('[data-mfb-summary]');
    const errorEl = root.querySelector('[data-mfb-error]');
    const loadingEl = root.querySelector('[data-mfb-loading]');
    const postcodeInput = root.querySelector('[data-mfb-postcode]');
    const locationsList = root.querySelector('[data-mfb-locations]');
    const locationsEmpty = root.querySelector('[data-mfb-locations-empty]');
    const locationsNoHeart = root.querySelector('[data-mfb-locations-no-heart]');
    const locationIntro = root.querySelector('[data-mfb-location-intro]');
    const addonBtns = root.querySelectorAll('[data-mfb-addon]');
    const totalSummary = root.querySelector('[data-mfb-total-summary]');
    const totalPrice = root.querySelector('[data-mfb-total-price]');
    const footerTotalValue = root.querySelector('[data-mfb-footer-total-value]');

    // Variant + price config from data attributes (variant IDs) and section settings.
    const variants = {
      base: root.dataset.baseVariant || '',
      heart: root.dataset.heartVariant || '',
      prostate: root.dataset.prostateVariant || '',
      heartProstate: root.dataset.heartProstateVariant || ''
    };

    const PRICES = { base: 1499, heart: 700, prostate: 600 };

    const state = {
      step: 1,
      addons: { heart: false, prostate: false },
      location: null,
      patient: {
        firstName: '',
        lastName: '',
        phone: '',
        dob: '',
        gender: '',
        preferredDate: '',
        timePreference: '',
        pacemaker: '',
        clinicalReason: ''
      }
    };

    const leadDays = parseInt(root.dataset.minLeadDays || '10', 10) || 10;
    const getMinDate = function () {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + leadDays);
      return d;
    };
    const toIso = function (d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd;
    };
    const getMinIso = function () { return toIso(getMinDate()); };
    const dateLabelFmt = (function () {
      try {
        return new Intl.DateTimeFormat(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) { return null; }
    })();
    const formatLongDate = function (d) {
      return dateLabelFmt ? dateLabelFmt.format(d) : toIso(d);
    };

    const preferredDateInput = root.querySelector('[data-mfb-field="preferredDate"]');
    const preferredDateHint = root.querySelector('[data-mfb-pd-hint]');
    const preferredDateError = root.querySelector('[data-mfb-pd-error]');

    const refreshPreferredDateHint = function () {
      if (!preferredDateHint) return;
      preferredDateHint.textContent = 'Bookings need at least ' + leadDays + ' days’ notice. Earliest available: ' + formatLongDate(getMinDate()) + '.';
    };

    const showPreferredDateError = function () {
      if (!preferredDateError) return;
      preferredDateError.textContent = 'That date is within ' + leadDays + ' days. Please choose ' + formatLongDate(getMinDate()) + ' or later.';
      preferredDateError.hidden = false;
    };

    const hidePreferredDateError = function () {
      if (preferredDateError) preferredDateError.hidden = true;
    };

    const enforcePreferredDate = function () {
      if (!preferredDateInput) return;
      const v = preferredDateInput.value;
      if (v && v < getMinIso()) {
        preferredDateInput.value = '';
        state.patient.preferredDate = '';
        showPreferredDateError();
      } else {
        hidePreferredDateError();
      }
    };

    const fieldInputs = root.querySelectorAll('[data-mfb-field]');
    fieldInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        state.patient[input.dataset.mfbField] = input.value.trim();
        if (input === preferredDateInput) enforcePreferredDate();
        updateNextEnabled();
      });
    });

    if (preferredDateInput) {
      preferredDateInput.setAttribute('min', getMinIso());
      refreshPreferredDateHint();
      preferredDateInput.addEventListener('change', function () {
        enforcePreferredDate();
        updateNextEnabled();
      });
      preferredDateInput.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' || e.key === 'Escape') return;
        e.preventDefault();
      });
      preferredDateInput.addEventListener('paste', function (e) { e.preventDefault(); });
      preferredDateInput.addEventListener('drop', function (e) { e.preventDefault(); });

      const openPicker = function () {
        preferredDateInput.setAttribute('min', getMinIso());
        refreshPreferredDateHint();
        if (typeof preferredDateInput.showPicker === 'function') {
          try { preferredDateInput.showPicker(); } catch (e) {}
        }
      };
      preferredDateInput.addEventListener('click', openPicker);
      preferredDateInput.addEventListener('focus', openPicker);
    }

    const pillInputs = root.querySelectorAll('[data-mfb-pill]');
    pillInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          state.patient[input.dataset.mfbPill] = input.value;
          updateNextEnabled();
        }
      });
    });

    triggerBtns.forEach(function (b) { b.addEventListener('click', openOverlay); });
    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    backBtn.addEventListener('click', function () { goToStep(state.step - 1); });
    nextBtn.addEventListener('click', function () {
      if (state.step === 4) submitBooking();
      else goToStep(state.step + 1);
    });

    addonBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.mfbAddon;
        state.addons[key] = !state.addons[key];
        btn.classList.toggle('is-selected', state.addons[key]);
        btn.setAttribute('aria-pressed', state.addons[key] ? 'true' : 'false');
        renderTotal();
        applyLocationFilter();
        // Drop the location pick if the new package is no longer supported there.
        if (state.location && state.addons.heart && !state.location.supportsHeart) {
          state.location = null;
          if (locationsList) locationsList.querySelectorAll('.mfb__location.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
        }
        updateNextEnabled();
      });
    });

    const locationButtons = root.querySelectorAll('[data-mfb-location]');
    locationButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        locationButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.location = {
          name: btn.dataset.name,
          address: btn.dataset.address,
          postcode: btn.dataset.postcode,
          handle: btn.dataset.handle,
          supportsHeart: btn.dataset.supportsHeart === '1'
        };
        updateNextEnabled();
      });
    });

    const postcodeStatus = root.querySelector('[data-mfb-postcode-status]');
    const originalLocationOrder = locationsList ? Array.from(locationsList.children) : [];
    let postcodeDebounce = null;
    let postcodeRequestId = 0;

    function setPostcodeStatus(message, kind) {
      if (!postcodeStatus) return;
      postcodeStatus.classList.remove('is-error', 'is-loading');
      if (!message) {
        postcodeStatus.hidden = true;
        postcodeStatus.textContent = '';
        return;
      }
      postcodeStatus.hidden = false;
      postcodeStatus.textContent = message;
      if (kind) postcodeStatus.classList.add('is-' + kind);
    }

    function clearLocationDistances() {
      root.querySelectorAll('[data-mfb-distance]').forEach(function (el) { el.textContent = ''; });
    }

    function restoreOriginalLocationOrder() {
      if (!locationsList) return;
      originalLocationOrder.forEach(function (li) { locationsList.appendChild(li); });
    }

    function distanceMiles(lat1, lng1, lat2, lng2) {
      const R = 3958.8;
      const toRad = function (d) { return d * Math.PI / 180; };
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function sortLocationsByDistance(userLat, userLng) {
      if (!locationsList) return;
      const items = Array.from(locationsList.querySelectorAll('li')).map(function (li) {
        const btn = li.querySelector('[data-mfb-location]');
        const lat = btn ? parseFloat(btn.dataset.lat) : NaN;
        const lng = btn ? parseFloat(btn.dataset.lng) : NaN;
        const ok = !isNaN(lat) && !isNaN(lng);
        return { li: li, btn: btn, distance: ok ? distanceMiles(userLat, userLng, lat, lng) : Infinity };
      });
      items.sort(function (a, b) { return a.distance - b.distance; });
      items.forEach(function (item) {
        locationsList.appendChild(item.li);
        const distEl = item.btn ? item.btn.querySelector('[data-mfb-distance]') : null;
        if (distEl) {
          if (isFinite(item.distance)) {
            const miles = item.distance < 10 ? item.distance.toFixed(1) : Math.round(item.distance).toString();
            distEl.textContent = miles + ' mi';
          } else {
            distEl.textContent = '';
          }
        }
      });
      try { locationsList.scrollTop = 0; } catch (e) {}
    }

    function lookupPostcode(raw) {
      const cleaned = raw.replace(/\s+/g, '').toUpperCase();
      if (cleaned.length < 2) {
        setPostcodeStatus('Enter at least an outcode (e.g. SW1A).', 'error');
        return;
      }
      const fullRe = /^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/;
      const outRe = /^[A-Z]{1,2}[0-9][A-Z0-9]?$/;
      let url;
      if (fullRe.test(cleaned)) {
        const m = cleaned.match(fullRe);
        url = 'https://api.postcodes.io/postcodes/' + encodeURIComponent(m[1] + ' ' + m[2]);
      } else if (outRe.test(cleaned)) {
        url = 'https://api.postcodes.io/outcodes/' + encodeURIComponent(cleaned);
      } else {
        setPostcodeStatus("That doesn't look like a UK postcode.", 'error');
        return;
      }

      const requestId = ++postcodeRequestId;
      setPostcodeStatus('Finding your closest clinic…', 'loading');

      fetch(url)
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (requestId !== postcodeRequestId) return;
          if (!res.ok || !res.body || res.body.status !== 200 || !res.body.result) {
            throw new Error('not-found');
          }
          const lat = parseFloat(res.body.result.latitude);
          const lng = parseFloat(res.body.result.longitude);
          if (isNaN(lat) || isNaN(lng)) throw new Error('no-coords');
          sortLocationsByDistance(lat, lng);
          setPostcodeStatus('Showing clinics nearest to ' + cleaned.replace(/^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/, '$1 $2') + ', closest first.');
        })
        .catch(function () {
          if (requestId !== postcodeRequestId) return;
          setPostcodeStatus("We couldn't find that postcode. Try a UK postcode like SW1A 1AA.", 'error');
        });
    }

    if (postcodeInput) {
      postcodeInput.addEventListener('input', function () {
        clearTimeout(postcodeDebounce);
        const v = postcodeInput.value.trim();
        if (!v) {
          postcodeRequestId++;
          restoreOriginalLocationOrder();
          clearLocationDistances();
          setPostcodeStatus('');
          return;
        }
        postcodeDebounce = setTimeout(function () { lookupPostcode(v); }, 350);
      });
    }

    function applyLocationFilter() {
      if (!locationsList) return;
      const heartRequired = state.addons.heart;
      let visible = 0;
      locationsList.querySelectorAll('[data-mfb-location-li]').forEach(function (li) {
        const supportsHeart = li.dataset.supportsHeart === '1';
        const show = heartRequired ? supportsHeart : true;
        li.hidden = !show;
        if (show) visible++;
      });

      if (locationIntro) {
        locationIntro.textContent = heartRequired
          ? 'Showing clinics that can perform a Full Body MRI with Cardiac upgrade.'
          : 'Showing clinics that can perform your Full Body MRI scan.';
      }

      if (locationsNoHeart) locationsNoHeart.hidden = !(heartRequired && visible === 0);
      if (locationsEmpty) locationsEmpty.hidden = visible !== 0 || (heartRequired && visible === 0);
    }

    renderTotal();
    applyLocationFilter();
    updateNextEnabled();
    renderSteps();

    // ── Abandonment capture ────────────────────────────────────────────────
    // Sends a JSON beacon to a Google Apps Script web app when the user closes
    // the overlay or leaves the page with partial booking data, so customer
    // service can follow up. One beacon per overlay-open session.
    const abandonmentUrl = root.dataset.abandonmentUrl || '';
    const flowId = root.dataset.flowId || 'full-body';
    let sessionId = '';
    let hasSentLead = false;

    function newSessionId() {
      try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {}
      return 'sid-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
    }

    function hasPartialPatientData() {
      return !!state.patient.phone;
    }

    function maybeSendLead() {
      if (!abandonmentUrl || hasSentLead) return;
      if (!hasPartialPatientData()) return;
      hasSentLead = true;
      const p = state.patient;
      const addons = [];
      if (state.addons.heart) addons.push('cardiac');
      if (state.addons.prostate) addons.push('prostate');
      const payload = {
        session_id: sessionId,
        flow: flowId,
        step_reached: state.step,
        first_name: p.firstName || '',
        last_name: p.lastName || '',
        phone: p.phone || '',
        dob: p.dob || '',
        gender: p.gender || '',
        preferred_date: p.preferredDate || '',
        time_preference: p.timePreference || '',
        pacemaker: p.pacemaker || '',
        clinical_reason: p.clinicalReason || '',
        body_part_1: '',
        body_part_2: '',
        scan_type: 'fullBody',
        addons: addons.join(','),
        location: state.location ? state.location.name : '',
        client_timestamp: new Date().toISOString(),
        user_agent: navigator.userAgent || ''
      };
      try {
        const blob = new Blob([JSON.stringify(payload)], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon) navigator.sendBeacon(abandonmentUrl, blob);
        else fetch(abandonmentUrl, { method: 'POST', body: blob, keepalive: true, mode: 'no-cors' }).catch(function () {});
      } catch (e) {}
    }

    window.addEventListener('pagehide', maybeSendLead);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') maybeSendLead();
    });

    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      sessionId = newSessionId();
      hasSentLead = false;
    }

    function closeOverlay() {
      maybeSendLead();
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function goToStep(n) {
      if (n < 1) n = 1;
      if (n > 4) n = 4;
      if (n === state.step) return;
      if (n > state.step && !canAdvanceFrom(state.step)) return;
      state.step = n;
      renderSteps();
      if (n === 4) renderSummary();
      const main = root.querySelector('.mfb__overlay-inner');
      if (main) main.scrollTop = 0;
      try { overlay.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    function canAdvanceFrom(s) {
      if (s === 1) return true;
      if (s === 2) return !!state.location;
      if (s === 3) {
        const p = state.patient;
        if (!(p.firstName && p.lastName && p.phone && p.dob && p.gender && p.preferredDate && p.timePreference && p.pacemaker && p.clinicalReason)) return false;
        if (state.addons.prostate && p.gender !== 'Male') return false;
        return p.preferredDate >= getMinIso();
      }
      return true;
    }

    function renderSteps() {
      stepTabs.forEach(function (t) {
        const i = parseInt(t.dataset.mfbStepTab, 10);
        t.classList.toggle('is-active', i === state.step);
        t.classList.toggle('is-complete', i < state.step);
      });
      panels.forEach(function (p) {
        const i = parseInt(p.dataset.mfbPanel, 10);
        const active = i === state.step;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
      backBtn.hidden = state.step === 1;
      if (nextLabel) nextLabel.textContent = state.step === 4 ? 'Confirm & continue to payment' : 'Continue';
      updateNextEnabled();
    }

    function updateNextEnabled() {
      nextBtn.disabled = !canAdvanceFrom(state.step);
    }

    function packageLabel() {
      const parts = ['Full Body MRI Scan'];
      if (state.addons.heart) parts.push('Cardiac upgrade');
      if (state.addons.prostate) parts.push('Prostate screening');
      return parts.join(' + ');
    }

    function packageTotal() {
      let t = PRICES.base;
      if (state.addons.heart) t += PRICES.heart;
      if (state.addons.prostate) t += PRICES.prostate;
      return t;
    }

    function formatGBP(n) {
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(n);
      } catch (e) {
        return '£' + n.toLocaleString();
      }
    }

    function renderTotal() {
      const priceText = formatGBP(packageTotal());
      if (totalSummary) totalSummary.textContent = packageLabel();
      if (totalPrice) totalPrice.textContent = priceText;
      if (footerTotalValue) footerTotalValue.textContent = priceText;
    }

    function renderSummary() {
      const rows = [];
      rows.push(summaryRow('Package', packageLabel() + '<small>' + formatGBP(packageTotal()) + '</small>', 1, true));
      if (state.location) {
        const addr = state.location.address || '';
        rows.push(summaryRow('Clinic', state.location.name + (addr ? '<small>' + escapeHtml(addr) + '</small>' : ''), 2, true));
      }
      const p = state.patient;
      const fullName = (p.firstName + ' ' + p.lastName).trim();
      if (fullName) rows.push(summaryRow('Patient', fullName + (p.dob ? '<small>DOB ' + escapeHtml(formatDate(p.dob)) + (p.gender ? ' · ' + escapeHtml(p.gender) : '') + '</small>' : ''), 3, true));
      if (p.phone) rows.push(summaryRow('Phone', p.phone, 3));
      if (p.preferredDate) rows.push(summaryRow('Appointment', formatDate(p.preferredDate) + (p.timePreference ? '<small>' + escapeHtml(p.timePreference) + '</small>' : ''), 3, true));
      if (p.pacemaker) rows.push(summaryRow('Pace-maker fitted', p.pacemaker, 3));
      if (p.clinicalReason) rows.push(summaryRow('Clinical reason', p.clinicalReason, 3));
      summaryEl.innerHTML = rows.join('');

      summaryEl.querySelectorAll('[data-edit-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          goToStep(parseInt(b.dataset.editStep, 10));
        });
      });
    }

    function formatDate(iso) {
      if (!iso) return '';
      const parts = iso.split('-');
      if (parts.length !== 3) return iso;
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    function summaryRow(label, value, step, allowHtml) {
      const valueHtml = allowHtml ? value : escapeHtml(value);
      return '<div class="mfb__summary-row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd><button type="button" class="mfb__summary-edit" data-edit-step="' + step + '">Change</button></div>';
    }

    function pickVariantId() {
      if (state.addons.heart && state.addons.prostate) return variants.heartProstate || variants.heart || variants.base;
      if (state.addons.heart) return variants.heart || variants.base;
      if (state.addons.prostate) return variants.prostate || variants.base;
      return variants.base;
    }

    function submitBooking() {
      errorEl.hidden = true;
      const variantId = pickVariantId();
      if (!variantId) {
        showError('No variant configured. Set the variant IDs in the section settings.');
        return;
      }

      loadingEl.hidden = false;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('properties[Package]', packageLabel());
      formData.append('properties[Cardiac upgrade]', state.addons.heart ? 'Yes' : 'No');
      formData.append('properties[Prostate screening]', state.addons.prostate ? 'Yes' : 'No');
      if (state.location) {
        formData.append('properties[Clinic]', state.location.name);
        if (state.location.address) formData.append('properties[Clinic address]', state.location.address);
      }
      const p = state.patient;
      if (p.firstName) formData.append('properties[Patient first name]', p.firstName);
      if (p.lastName) formData.append('properties[Patient last name]', p.lastName);
      if (p.phone) formData.append('properties[Patient phone]', p.phone);
      if (p.dob) formData.append('properties[Patient DOB]', formatDate(p.dob));
      if (p.gender) formData.append('properties[Gender]', p.gender);
      if (p.preferredDate) formData.append('properties[Preferred appointment date]', formatDate(p.preferredDate));
      if (p.timePreference) formData.append('properties[Time preference]', p.timePreference);
      if (p.pacemaker) formData.append('properties[Pace-maker fitted]', p.pacemaker);
      if (p.clinicalReason) formData.append('properties[Clinical reason for scan]', p.clinicalReason);

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          // Note: we intentionally DO NOT suppress the abandonment beacon here.
          // Reaching Shopify checkout != completing payment. If the user bails
          // at the Shopify checkout, they're a valid lead. Staff dedupe by
          // phone against placed orders before calling.
          const url = root.dataset.checkoutUrl || '/checkout';
          window.location.href = url;
        })
        .catch(function (err) {
          loadingEl.hidden = true;
          showError(err.message || 'Could not add to cart. Please try again.');
        });
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mri-full-body-flow"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-mfb-section]:not([data-mfb-init])');
  sections.forEach(initBookingFlow);

  function initBookingFlow(root) {
    root.setAttribute('data-mfb-init', '1');

    const overlay = root.querySelector('[data-mfb-overlay]');
    const triggerBtns = root.querySelectorAll('[data-mfb-open]');
    const closeBtn = root.querySelector('[data-mfb-close]');
    const backBtn = root.querySelector('[data-mfb-back]');
    const nextBtn = root.querySelector('[data-mfb-next]');
    const nextLabel = root.querySelector('[data-mfb-next-label]');
    const stepTabs = root.querySelectorAll('[data-mfb-step-tab]');
    const panels = root.querySelectorAll('[data-mfb-panel]');
    const summaryEl = root.querySelector('[data-mfb-summary]');
    const errorEl = root.querySelector('[data-mfb-error]');
    const loadingEl = root.querySelector('[data-mfb-loading]');
    const postcodeInput = root.querySelector('[data-mfb-postcode]');
    const locationsList = root.querySelector('[data-mfb-locations]');
    const locationsEmpty = root.querySelector('[data-mfb-locations-empty]');
    const locationsNoHeart = root.querySelector('[data-mfb-locations-no-heart]');
    const locationIntro = root.querySelector('[data-mfb-location-intro]');
    const addonBtns = root.querySelectorAll('[data-mfb-addon]');
    const totalSummary = root.querySelector('[data-mfb-total-summary]');
    const totalPrice = root.querySelector('[data-mfb-total-price]');

    // Variant + price config from data attributes (variant IDs) and section settings.
    const variants = {
      base: root.dataset.baseVariant || '',
      heart: root.dataset.heartVariant || '',
      prostate: root.dataset.prostateVariant || '',
      heartProstate: root.dataset.heartProstateVariant || ''
    };

    const PRICES = { base: 1499, heart: 700, prostate: 600 };

    const state = {
      step: 1,
      addons: { heart: false, prostate: false },
      location: null,
      patient: {
        firstName: '',
        lastName: '',
        dob: '',
        gender: '',
        preferredDate: '',
        timePreference: '',
        pacemaker: '',
        clinicalReason: ''
      }
    };

    const leadDays = parseInt(root.dataset.minLeadDays || '10', 10) || 10;
    const getMinDate = function () {
      const d = new Date();
      d.setHours(0, 0, 0, 0);
      d.setDate(d.getDate() + leadDays);
      return d;
    };
    const toIso = function (d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return yyyy + '-' + mm + '-' + dd;
    };
    const getMinIso = function () { return toIso(getMinDate()); };
    const dateLabelFmt = (function () {
      try {
        return new Intl.DateTimeFormat(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      } catch (e) { return null; }
    })();
    const formatLongDate = function (d) {
      return dateLabelFmt ? dateLabelFmt.format(d) : toIso(d);
    };

    const preferredDateInput = root.querySelector('[data-mfb-field="preferredDate"]');
    const preferredDateHint = root.querySelector('[data-mfb-pd-hint]');
    const preferredDateError = root.querySelector('[data-mfb-pd-error]');

    const refreshPreferredDateHint = function () {
      if (!preferredDateHint) return;
      preferredDateHint.textContent = 'Bookings need at least ' + leadDays + ' days’ notice. Earliest available: ' + formatLongDate(getMinDate()) + '.';
    };

    const showPreferredDateError = function () {
      if (!preferredDateError) return;
      preferredDateError.textContent = 'That date is within ' + leadDays + ' days. Please choose ' + formatLongDate(getMinDate()) + ' or later.';
      preferredDateError.hidden = false;
    };

    const hidePreferredDateError = function () {
      if (preferredDateError) preferredDateError.hidden = true;
    };

    const enforcePreferredDate = function () {
      if (!preferredDateInput) return;
      const v = preferredDateInput.value;
      if (v && v < getMinIso()) {
        preferredDateInput.value = '';
        state.patient.preferredDate = '';
        showPreferredDateError();
      } else {
        hidePreferredDateError();
      }
    };

    const fieldInputs = root.querySelectorAll('[data-mfb-field]');
    fieldInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        state.patient[input.dataset.mfbField] = input.value.trim();
        if (input === preferredDateInput) enforcePreferredDate();
        updateNextEnabled();
      });
    });

    if (preferredDateInput) {
      preferredDateInput.setAttribute('min', getMinIso());
      refreshPreferredDateHint();
      preferredDateInput.addEventListener('change', function () {
        enforcePreferredDate();
        updateNextEnabled();
      });
      preferredDateInput.addEventListener('keydown', function (e) {
        if (e.key === 'Tab' || e.key === 'Escape') return;
        e.preventDefault();
      });
      preferredDateInput.addEventListener('paste', function (e) { e.preventDefault(); });
      preferredDateInput.addEventListener('drop', function (e) { e.preventDefault(); });

      const openPicker = function () {
        preferredDateInput.setAttribute('min', getMinIso());
        refreshPreferredDateHint();
        if (typeof preferredDateInput.showPicker === 'function') {
          try { preferredDateInput.showPicker(); } catch (e) {}
        }
      };
      preferredDateInput.addEventListener('click', openPicker);
      preferredDateInput.addEventListener('focus', openPicker);
    }

    const pillInputs = root.querySelectorAll('[data-mfb-pill]');
    pillInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) {
          state.patient[input.dataset.mfbPill] = input.value;
          updateNextEnabled();
        }
      });
    });

    triggerBtns.forEach(function (b) { b.addEventListener('click', openOverlay); });
    closeBtn.addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeOverlay();
    });

    backBtn.addEventListener('click', function () { goToStep(state.step - 1); });
    nextBtn.addEventListener('click', function () {
      if (state.step === 4) submitBooking();
      else goToStep(state.step + 1);
    });

    addonBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.dataset.mfbAddon;
        state.addons[key] = !state.addons[key];
        btn.classList.toggle('is-selected', state.addons[key]);
        btn.setAttribute('aria-pressed', state.addons[key] ? 'true' : 'false');
        renderTotal();
        applyLocationFilter();
        // Drop the location pick if the new package is no longer supported there.
        if (state.location && state.addons.heart && !state.location.supportsHeart) {
          state.location = null;
          if (locationsList) locationsList.querySelectorAll('.mfb__location.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
        }
        updateNextEnabled();
      });
    });

    const locationButtons = root.querySelectorAll('[data-mfb-location]');
    locationButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        locationButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.location = {
          name: btn.dataset.name,
          address: btn.dataset.address,
          postcode: btn.dataset.postcode,
          handle: btn.dataset.handle,
          supportsHeart: btn.dataset.supportsHeart === '1'
        };
        updateNextEnabled();
      });
    });

    const postcodeStatus = root.querySelector('[data-mfb-postcode-status]');
    const originalLocationOrder = locationsList ? Array.from(locationsList.children) : [];
    let postcodeDebounce = null;
    let postcodeRequestId = 0;

    function setPostcodeStatus(message, kind) {
      if (!postcodeStatus) return;
      postcodeStatus.classList.remove('is-error', 'is-loading');
      if (!message) {
        postcodeStatus.hidden = true;
        postcodeStatus.textContent = '';
        return;
      }
      postcodeStatus.hidden = false;
      postcodeStatus.textContent = message;
      if (kind) postcodeStatus.classList.add('is-' + kind);
    }

    function clearLocationDistances() {
      root.querySelectorAll('[data-mfb-distance]').forEach(function (el) { el.textContent = ''; });
    }

    function restoreOriginalLocationOrder() {
      if (!locationsList) return;
      originalLocationOrder.forEach(function (li) { locationsList.appendChild(li); });
    }

    function distanceMiles(lat1, lng1, lat2, lng2) {
      const R = 3958.8;
      const toRad = function (d) { return d * Math.PI / 180; };
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function sortLocationsByDistance(userLat, userLng) {
      if (!locationsList) return;
      const items = Array.from(locationsList.querySelectorAll('li')).map(function (li) {
        const btn = li.querySelector('[data-mfb-location]');
        const lat = btn ? parseFloat(btn.dataset.lat) : NaN;
        const lng = btn ? parseFloat(btn.dataset.lng) : NaN;
        const ok = !isNaN(lat) && !isNaN(lng);
        return { li: li, btn: btn, distance: ok ? distanceMiles(userLat, userLng, lat, lng) : Infinity };
      });
      items.sort(function (a, b) { return a.distance - b.distance; });
      items.forEach(function (item) {
        locationsList.appendChild(item.li);
        const distEl = item.btn ? item.btn.querySelector('[data-mfb-distance]') : null;
        if (distEl) {
          if (isFinite(item.distance)) {
            const miles = item.distance < 10 ? item.distance.toFixed(1) : Math.round(item.distance).toString();
            distEl.textContent = miles + ' mi';
          } else {
            distEl.textContent = '';
          }
        }
      });
      try { locationsList.scrollTop = 0; } catch (e) {}
    }

    function lookupPostcode(raw) {
      const cleaned = raw.replace(/\s+/g, '').toUpperCase();
      if (cleaned.length < 2) {
        setPostcodeStatus('Enter at least an outcode (e.g. SW1A).', 'error');
        return;
      }
      const fullRe = /^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/;
      const outRe = /^[A-Z]{1,2}[0-9][A-Z0-9]?$/;
      let url;
      if (fullRe.test(cleaned)) {
        const m = cleaned.match(fullRe);
        url = 'https://api.postcodes.io/postcodes/' + encodeURIComponent(m[1] + ' ' + m[2]);
      } else if (outRe.test(cleaned)) {
        url = 'https://api.postcodes.io/outcodes/' + encodeURIComponent(cleaned);
      } else {
        setPostcodeStatus("That doesn't look like a UK postcode.", 'error');
        return;
      }

      const requestId = ++postcodeRequestId;
      setPostcodeStatus('Finding your closest clinic…', 'loading');

      fetch(url)
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (requestId !== postcodeRequestId) return;
          if (!res.ok || !res.body || res.body.status !== 200 || !res.body.result) {
            throw new Error('not-found');
          }
          const lat = parseFloat(res.body.result.latitude);
          const lng = parseFloat(res.body.result.longitude);
          if (isNaN(lat) || isNaN(lng)) throw new Error('no-coords');
          sortLocationsByDistance(lat, lng);
          setPostcodeStatus('Showing clinics nearest to ' + cleaned.replace(/^([A-Z]{1,2}[0-9][A-Z0-9]?)([0-9][A-Z]{2})$/, '$1 $2') + ', closest first.');
        })
        .catch(function () {
          if (requestId !== postcodeRequestId) return;
          setPostcodeStatus("We couldn't find that postcode. Try a UK postcode like SW1A 1AA.", 'error');
        });
    }

    if (postcodeInput) {
      postcodeInput.addEventListener('input', function () {
        clearTimeout(postcodeDebounce);
        const v = postcodeInput.value.trim();
        if (!v) {
          postcodeRequestId++;
          restoreOriginalLocationOrder();
          clearLocationDistances();
          setPostcodeStatus('');
          return;
        }
        postcodeDebounce = setTimeout(function () { lookupPostcode(v); }, 350);
      });
    }

    function applyLocationFilter() {
      if (!locationsList) return;
      const heartRequired = state.addons.heart;
      let visible = 0;
      locationsList.querySelectorAll('[data-mfb-location-li]').forEach(function (li) {
        const supportsHeart = li.dataset.supportsHeart === '1';
        const show = heartRequired ? supportsHeart : true;
        li.hidden = !show;
        if (show) visible++;
      });

      if (locationIntro) {
        locationIntro.textContent = heartRequired
          ? 'Showing clinics that can perform a Full Body MRI with Cardiac upgrade.'
          : 'Showing clinics that can perform your Full Body MRI scan.';
      }

      if (locationsNoHeart) locationsNoHeart.hidden = !(heartRequired && visible === 0);
      if (locationsEmpty) locationsEmpty.hidden = visible !== 0 || (heartRequired && visible === 0);
    }

    renderTotal();
    applyLocationFilter();
    updateNextEnabled();
    renderSteps();

    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function goToStep(n) {
      if (n < 1) n = 1;
      if (n > 4) n = 4;
      if (n === state.step) return;
      if (n > state.step && !canAdvanceFrom(state.step)) return;
      state.step = n;
      renderSteps();
      if (n === 4) renderSummary();
      const main = root.querySelector('.mfb__overlay-inner');
      if (main) main.scrollTop = 0;
      try { overlay.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) {}
    }

    function canAdvanceFrom(s) {
      if (s === 1) return true;
      if (s === 2) return !!state.location;
      if (s === 3) {
        const p = state.patient;
        if (!(p.firstName && p.lastName && p.dob && p.gender && p.preferredDate && p.timePreference && p.pacemaker && p.clinicalReason)) return false;
        if (state.addons.prostate && p.gender !== 'Male') return false;
        return p.preferredDate >= getMinIso();
      }
      return true;
    }

    function renderSteps() {
      stepTabs.forEach(function (t) {
        const i = parseInt(t.dataset.mfbStepTab, 10);
        t.classList.toggle('is-active', i === state.step);
        t.classList.toggle('is-complete', i < state.step);
      });
      panels.forEach(function (p) {
        const i = parseInt(p.dataset.mfbPanel, 10);
        const active = i === state.step;
        p.classList.toggle('is-active', active);
        p.hidden = !active;
      });
      backBtn.hidden = state.step === 1;
      if (nextLabel) nextLabel.textContent = state.step === 4 ? 'Confirm & continue to payment' : 'Continue';
      updateNextEnabled();
    }

    function updateNextEnabled() {
      nextBtn.disabled = !canAdvanceFrom(state.step);
    }

    function packageLabel() {
      const parts = ['Full Body MRI Scan'];
      if (state.addons.heart) parts.push('Cardiac upgrade');
      if (state.addons.prostate) parts.push('Prostate screening');
      return parts.join(' + ');
    }

    function packageTotal() {
      let t = PRICES.base;
      if (state.addons.heart) t += PRICES.heart;
      if (state.addons.prostate) t += PRICES.prostate;
      return t;
    }

    function formatGBP(n) {
      try {
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(n);
      } catch (e) {
        return '£' + n.toLocaleString();
      }
    }

    function renderTotal() {
      if (totalSummary) totalSummary.textContent = packageLabel();
      if (totalPrice) totalPrice.textContent = formatGBP(packageTotal());
    }

    function renderSummary() {
      const rows = [];
      rows.push(summaryRow('Package', packageLabel() + '<small>' + formatGBP(packageTotal()) + '</small>', 1, true));
      if (state.location) {
        const addr = state.location.address || '';
        rows.push(summaryRow('Clinic', state.location.name + (addr ? '<small>' + escapeHtml(addr) + '</small>' : ''), 2, true));
      }
      const p = state.patient;
      const fullName = (p.firstName + ' ' + p.lastName).trim();
      if (fullName) rows.push(summaryRow('Patient', fullName + (p.dob ? '<small>DOB ' + escapeHtml(formatDate(p.dob)) + (p.gender ? ' · ' + escapeHtml(p.gender) : '') + '</small>' : ''), 3, true));
      if (p.preferredDate) rows.push(summaryRow('Appointment', formatDate(p.preferredDate) + (p.timePreference ? '<small>' + escapeHtml(p.timePreference) + '</small>' : ''), 3, true));
      if (p.pacemaker) rows.push(summaryRow('Pace-maker fitted', p.pacemaker, 3));
      if (p.clinicalReason) rows.push(summaryRow('Clinical reason', p.clinicalReason, 3));
      summaryEl.innerHTML = rows.join('');

      summaryEl.querySelectorAll('[data-edit-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          goToStep(parseInt(b.dataset.editStep, 10));
        });
      });
    }

    function formatDate(iso) {
      if (!iso) return '';
      const parts = iso.split('-');
      if (parts.length !== 3) return iso;
      return parts[2] + '/' + parts[1] + '/' + parts[0];
    }

    function summaryRow(label, value, step, allowHtml) {
      const valueHtml = allowHtml ? value : escapeHtml(value);
      return '<div class="mfb__summary-row"><dt>' + escapeHtml(label) + '</dt><dd>' + valueHtml + '</dd><button type="button" class="mfb__summary-edit" data-edit-step="' + step + '">Change</button></div>';
    }

    function pickVariantId() {
      if (state.addons.heart && state.addons.prostate) return variants.heartProstate || variants.heart || variants.base;
      if (state.addons.heart) return variants.heart || variants.base;
      if (state.addons.prostate) return variants.prostate || variants.base;
      return variants.base;
    }

    function submitBooking() {
      errorEl.hidden = true;
      const variantId = pickVariantId();
      if (!variantId) {
        showError('No variant configured. Set the variant IDs in the section settings.');
        return;
      }

      loadingEl.hidden = false;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('properties[Package]', packageLabel());
      formData.append('properties[Cardiac upgrade]', state.addons.heart ? 'Yes' : 'No');
      formData.append('properties[Prostate screening]', state.addons.prostate ? 'Yes' : 'No');
      if (state.location) {
        formData.append('properties[Clinic]', state.location.name);
        if (state.location.address) formData.append('properties[Clinic address]', state.location.address);
      }
      const p = state.patient;
      if (p.firstName) formData.append('properties[Patient first name]', p.firstName);
      if (p.lastName) formData.append('properties[Patient last name]', p.lastName);
      if (p.dob) formData.append('properties[Patient DOB]', formatDate(p.dob));
      if (p.gender) formData.append('properties[Gender]', p.gender);
      if (p.preferredDate) formData.append('properties[Preferred appointment date]', formatDate(p.preferredDate));
      if (p.timePreference) formData.append('properties[Time preference]', p.timePreference);
      if (p.pacemaker) formData.append('properties[Pace-maker fitted]', p.pacemaker);
      if (p.clinicalReason) formData.append('properties[Clinical reason for scan]', p.clinicalReason);

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart'); });
          const url = root.dataset.checkoutUrl || '/checkout';
          window.location.href = url;
        })
        .catch(function (err) {
          loadingEl.hidden = true;
          showError(err.message || 'Could not add to cart. Please try again.');
        });
    }

    function showError(msg) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mri-patient-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.mps:not([data-mps-init])');
  sections.forEach(function (root) {
    root.setAttribute('data-mps-init', '1');
    const media = root.querySelector('[data-mps-media]');
    const trigger = root.querySelector('[data-mps-play]');
    const tmpl = root.querySelector('[data-mps-iframe-template]');
    if (!media || !trigger || !tmpl) return;

    trigger.addEventListener('click', function () {
      const node = tmpl.content.firstElementChild;
      if (!node) return;
      const clone = node.cloneNode(true);
      trigger.remove();
      const dur = media.querySelector('.mps__duration');
      if (dur) dur.remove();
      media.appendChild(clone);
      try { clone.focus(); } catch (e) {}
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
